import React, { useState, useEffect, FC, useCallback, useRef } from "react";
import {
  Badge,
  Row,
  Col,
  Button,
  Modal,
  ModalBody,
  Card,
  Spinner,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Alert,
  UncontrolledDropdown,
} from "reactstrap";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
} from "../../components/Component";
import FormatDate from "../masters/DateFormater";
import costCenterApis from "../../api/master/costCenter";
import GeneralLedgerApis from "../../api/master/generalLedger";
import departments from "../../api/master/departments";
import { FormProvider, useForm } from "react-hook-form";
import {
  PaperClipOutlined,
  DownloadOutlined,
  DeleteOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  EditOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import {
  Form,
  TableColumnsType,
  Input,
  Table,
  Timeline,
  Collapse as AntCollapse,
  Descriptions,
  Modal as AntModal,
  Upload,
  Flex,
  Spin,
  Empty,
  Select,
} from "antd";
import { nanoid } from "nanoid";
import FormSelect from "../form-components/SelectComponent";
import FormInput from "../form-components/InputComponent";
import FormDatePicker from "../form-components/DatePicker";
import deliveryAddressApis from "../../api/master/deliveryAddress";
import purchaseOrderApis from "../../api/master/PurchaseOrder";
import { Popover, Steps } from "antd";
import Swal from "sweetalert2";
import CropperComponent from "../components/CropperComponent";
import SignatureModal from "./SignatureModal";
import ImageUploadCropper from "../components/ImageUploadCropper";
import dayjs from "dayjs";
import ChangeToBuyerDrawer from "./ChangeToBuyerModal";
import Misc from "../masters/Misc";
import { UploadFile } from "antd/es/upload/interface";
import RateContractAside from "./RateContractAside";
import statusMapper from "./StatusMapper";
import { useLocation, useNavigate } from "react-router";
import axios from "axios";
import "react-quill/dist/quill.snow.css";
import budgetApis from "../../api/master/budget";
import purchaseOrderCreation from "../../api/purchase-orders/pruchaseOrderCreation";
import { useSelector } from "react-redux";
import PdfGenerator from "./TestPDF";
import { formatCurrency, formatDecimal } from "../../utils/Utils";
import FormTextArea from "../form-components/TextAreaComponent";
import EmailCreationModal from "../EmailCreationModal";
import contractorsApis from "../../api/master/contractors";
import supplierApis from "../../api/master/supplier";
import MaterialModal from "./EditRCMaterialModal";
import rateContract from "../../api/rate-contract/rateContract";
import { Link } from "react-router-dom";
const { Dragger } = Upload;
const { Panel } = AntCollapse;
const { FormatCurrency, beforeUpload } = Misc;

interface SelectOptions {
  label: string;
  value: string;
}

type Cess = {
  cessName: string;
  cessType?: string;
  cessPercentage?: string;
  cessAmount?: string;
};
interface TaxConfiguration {
  taxType: string;
  gstType?: string; //IGST or CGST+SGST
  cess?: Cess[];
}

interface CurrencyData {
  description: string;
  currency_code: string;
  currency_symbol: string;
  currency_format: string;
  example: string;
}

const ViewOrderDetails: FC<any> = ({ orderNumber, previousPath, extra }) => {
  const pdfBlobData: any = useRef(null);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [shareOptionsToggle, setShareOptionsToggle] = useState(false);
  const { data: accessibility } = useSelector(
    (state: any) => state.accessibility
  );

  const location = useLocation();
  const rcStatus = location.state?.status;

  const [allowedActions, setAllowedActions] = useState<any>({
    add: 0,
    view: 0,
    edit: 0,
    approve: 0,
    reject: 0,
    cancel: 0,
  });
  const [invoiceAllowedActions, setInvoiceAllowedActions] = useState<any>({
    add: 0,
    view: 0,
    edit: 0,
    approve: 0,
    reject: 0,
    cancel: 0,
  });
  const [materialCategoryOptions, setMaterialCategoryOptions] = useState([]);
  const { data: currentUser } = useSelector((state: any) => state.currentUser);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [disableApprove, setDisableApprove] = useState(false);
  const [disableReject, setDisableReject] = useState(false);
  const [disableAccept, setDisableAccept] = useState(false);
  const [disableRejectS, setDisableRejectS] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [OriginalData, setOriginalData] = useState<any>({});
  const [poStatus, setPoStatus] = useState<any>("");
  const [showSubmitBtm, setShowSubmitBtm] = useState(false);
  const [sm, setSm] = useState(false);
  const [tab, setTab] = useState("1");
  const [screenSize, setScreenSize] = useState(0);
  const [mobileView, setMobileView] = useState(false);
  const [taxConfiguration, setTaxConfiguration] = useState<TaxConfiguration>();
  const [instructionsVisible, setInstructionsVisible] = useState(false);
  const [termsVisible, setTermsVisible] = useState(false);
  const [materialData, setMaterialData] = useState<any>({});
  const [supplierList, setSupplierList] = useState<any>([]);
  const [attachments, setAttachments] = useState<any>([]);
  const [deletedAttachments, setDeletedAttachments] = useState<any>([]);
  const [newAttachments, setNewAttachments] = useState<any>([]);
  const [showSignatureModel, setShowSignatureModel] = useState<boolean>(false);
  const [showCropModel, setShowCropModel] = useState<boolean>(false);
  const [signature, setSignature] = useState({
    isActive: false,
    label: "Authorised Signatory",
    image: null as string | null,
  });
  const [activeSignatureContext, setActiveSignatureContext] = useState<
    "APPROVE" | "REJECT" | null
  >(null);
  const [isStrictMode, setIsStrictMode] = useState<boolean>(false);
  const [deliveryAddressList, setDeliveryAddressList] = useState<any>([]);
  const [crRejectModal, setCrRejectModal] = useState<boolean>(false);
  const [disapprovePO, setDisapprovePO] = useState<boolean>(false);
  const [isModalApproveVisible, setIsModalApproveVisible] = useState(false);
  const [isModalRejectedVisible, setIsModalRejectedVisible] = useState(false);
  const [isModalInactivateVisible, setIsModalInactivateVisible] =
    useState(false);
  const [pendingRejectReason, setPendingRejectReason] = useState<string>("");
  const [pendingInactivateReason, setPendingInactivateReason] =
    useState<string>("");
  const [supplierOptions, setSupplierOptions] = useState<SelectOptions[]>([]);
  const [costCenterOptions, setCostCenterOptions] = useState<SelectOptions[]>(
    []
  );
  const [sitesOptions, setSitesOptions] = useState<SelectOptions[]>([]);
  const [generalLedgerOptions, setGeneralLedgerOptions] = useState<
    SelectOptions[]
  >([]);
  const [departmentOptions, setDepartmentOptions] = useState<SelectOptions[]>(
    []
  );
  const [budgetOptions, setBudgetOptions] = useState<SelectOptions[]>([]);
  const [contractorOptions, setContractorOptions] = useState<SelectOptions[]>(
    []
  );

  const [deliveryAddressOptions, setDeliveryAddressOptions] = useState<
    SelectOptions[]
  >([]);
  const [currency, setCurrency] = useState<CurrencyData>({
    description: "",
    currency_code: "",
    currency_symbol: "",
    currency_format: "",
    example: "",
  });

  const [DMS, setDMS] = useState<any>([]);
  const [editLineRow, setEditLineRow] = useState<any>();
  const [changeToBuyerData, setChangeToBuyerData] = useState<any>();
  const [generalInformationEdit, setGeneralInformationEdit] = useState(false);
  const [termsAndConditions, setTermsAndConditions] = useState<any>("");
  const [newTermsAndConditions, setNewTermsAndConditions] = useState<any>("");
  const [instructions, setInstructions] = useState("");
  const [newInstructions, setNewInstructions] = useState<any>("");
  const [isInstructionsChanged, setIsInstructionsChanged] = useState(false);
  const [currentUserId, setCurrentUserId] = useState<any>(null);
  const [approverIds, setApproverIds] = useState<any>([]);
  const [isTermsAndConditionsChanged, setIsTermsAndConditionsChanged] =
    useState(false);
  const [showConvertToPOModal, setShowConvertToPOModal] = useState(false);
  const [selectedMaterialsForPO, setSelectedMaterialsForPO] = useState<any[]>(
    []
  );

  const methods = useForm({
    mode: "onChange",
  });

  const {
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = methods;

  const siteIdWatch = watch("siteId");
  const termsAndConditionsWatch = watch("termsAndConditions");
  const instructionsWatch = watch("instructions");
  useEffect(() => {
    if (termsAndConditionsWatch) {
      setNewTermsAndConditions(termsAndConditionsWatch);
    }
  }, [termsAndConditionsWatch]);

  useEffect(() => {
    if (instructionsWatch) {
      setNewInstructions(instructionsWatch);
    }
  }, [instructionsWatch]);

  useEffect(() => {
    if (siteIdWatch) {
      fetchBudgetDetails(siteIdWatch);
      fetchContractorList(siteIdWatch + "");
    }
  }, [siteIdWatch]);

  const updatePdfBlobDataRef = (newData: any) => {
    try {
      pdfBlobData.current = newData;
    } catch (error) { }
  };

  const TriggerEmail = async (emailData: any, _methods: any) => {
    try {
      const formData = new FormData();
      formData.append("msgType", "purchaseOrderCreated");
      formData.append("logo", currentUser?.orgLogo);
      formData.append("email", emailData?.to);
      formData.append("cc", emailData?.cc);
      formData.append("bcc", emailData?.bcc);
      if (emailData?.attachments?.length > 0) {
        emailData?.attachments?.forEach((attachment: any, index: number) => {
          if (!attachment) {
            return;
          }
          let file: any = null;
          if (index == 0) {
            file = new File(
              [pdfBlobData.current],
              OriginalData?.orderId + ".pdf",
              {
                type: "application/pdf",
              }
            );
          } else {
            file = attachment?.originFileObj;
          }
          formData.append(`files`, file);
        });
      }
      const response: any = await purchaseOrderApis.sendOrderEmailNotification(
        orderNumber,
        formData
      );
      const { data, status } = response;
      if (status) {
        Swal.fire("Success", "Email has been sent successfully", "success");
        _methods.reset();
        setShowEmailModal(false);
      }
    } catch (error) {
      console.log(error);
      setShowEmailModal(false);
    }
  };

  useEffect(() => {
    if (accessibility) {
      try {
        const rcAccess = accessibility["Rate Contract"];
        const invoiceAccess = accessibility["Invoice"];
        if (rcAccess) {
          const { add, view, edit, approve, reject, cancel } = rcAccess;
          setAllowedActions({ add, view, edit, approve, reject, cancel });
        }
        if (invoiceAccess) {
          const { add, view, edit, approve, reject, cancel } = invoiceAccess;
          setInvoiceAllowedActions({
            add,
            view,
            edit,
            approve,
            reject,
            cancel,
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
  }, [accessibility]);

  useEffect(() => {
    if (disapprovePO == false) {
      setDisableReject(false);
    }
  }, [disapprovePO]);
  useEffect(() => {
    if (crRejectModal == false) {
      setDisableRejectS(false);
    }
  }, [crRejectModal]);
  const fetchCategorys = async () => {
    try {
      const { data, status } = await supplierApis.fetchSupplierCategory();
      if (status) {
        const categoryOption = data.map((item: any) => ({
          label: item.category,
          value: item.id.toString(),
        }));
        setMaterialCategoryOptions(categoryOption);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchBudgetDetails = async (siteId: any) => {
    try {
      const { data, status } = await budgetApis.getBudgetBySite(siteId);

      if (status) {
        let budgetOptions = data.map((item: any) => ({
          label: item.budgetName,
          value: item.headerId,
        }));
        setBudgetOptions(budgetOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchContractorList = async (siteId: any) => {
    try {
      const { data, status } = await contractorsApis.fetchContractorBySiteId({
        id: siteId,
      });
      if (status) {
        let contractorOptions = data.map((item: any) => ({
          label: item?.companyName,
          value: item?.contractorID?.toString(),
        }));
        setContractorOptions(contractorOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const [addNewRowModel, setAddNewRowModel] = useState<boolean>(false);

  useEffect(() => {
    if (currentUser) {
      const { siteAccessibility, id } = currentUser;
      setCurrentUserId(id);
      if (siteAccessibility) {
        const sitesOptions = siteAccessibility?.map((item: any) => ({
          label: item.siteName,
          value: item.siteID.toString(),
        }));
        setSitesOptions(sitesOptions);
      }
    }
  }, [currentUser]);
  useEffect(() => {
    fetchCategorys();
    fetchOrderDetails();
    fetchDeliveryAddress();
    fetchSupplier();
    fetchCostCenter();
    fetchGeneralLedger();
    fetchDepartment();
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    const headerClick = () => setSm(false);
    document
      .getElementsByClassName("nk-header")[0]
      ?.addEventListener("click", headerClick);

    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
      document
        .getElementsByClassName("nk-header")[0]
        ?.removeEventListener("click", headerClick);
    };
  }, []);

  const viewChange = () => {
    setScreenSize(window.innerWidth);
    if (window.innerWidth < 990) {
      setMobileView(true);
    } else {
      setMobileView(false);
      setSm(false);
    }
  };

  const handleAttachmentChange = (info: { fileList: UploadFile[] }) => {
    setNewAttachments((pre: any) => {
      return [...pre, ...info.fileList];
    });
    setShowSubmitBtm(true);
  };

  const fetchHtmlContentFromUrl = async (url: string) => {
    try {
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "text/html",
        },
      });

      return response?.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  const fetchOrderDetails = async () => {
    try {
      // Extract rateContractId from orderNumber (assuming orderNumber is the rateContractId)
      const rateContractId = orderNumber ? Number(orderNumber) : null;
      if (!rateContractId) {
        console.error("Rate Contract ID is required");
        setIsLoading(false);
        return;
      }

      const res = await rateContract.fetchRateContract(rateContractId);
      const { data, status, message } = res;
      if (status && data) {
        // Map API response to component expected format
        const mappedData = {
          // Map contract fields
          orderId: data.contractReferenceId,
          orderNumber: data.contractReferenceId,
          orderDate: data.contractDate || data.startDate,
          orderStatus: data.approvalStatus || data.status,
          status: data.status,
          contractType: data.contractType || "Quantity",
          contractFor: data.contractFor,
          description: data.description,
          supplierId: data.supplierId,
          supplierName: data.supplierName,
          startDate: data.startDate,
          endDate: data.endDate,
          expiryReminder: data.expiryReminderDays,
          contractDate: data.contractDate,
          autoRelease:
            data.autoRelease === 1 || data.autoRelease === true
              ? "true"
              : "false",
          paymentTerms: data.paymentTerms,
          advancePercentage: data.advancePercentage,
          creditDays: data.creditDays,
          leadDays: data.leadDays,
          siteId: data.contractSites?.[0]?.siteId || null,
          siteIds: data.contractSites?.map((site: any) => site.siteId) || [],
          siteNames:
            data.contractSites?.map((site: any) => site.siteName) || [],
          // Map contract lines to lineItems
          lineItems:
            data.contractLines?.map((line: any, index: number) => {
              // Map contractPrices to priceSlabArray format and sort by minQty
              const priceSlabArray =
                line.contractPrices
                  ?.map((price: any) => ({
                    minquantity: Number(price.minQty)?.toString() || "0",
                    maxquantity: Number(price.maxQty)?.toString() || "0",
                    unitPrice: Number(price.unitPrice)?.toString() || "0",
                    rateContractPriceId: price.rateContractPriceId || null,
                  }))
                  .sort(
                    (a: any, b: any) =>
                      Number(a.minquantity) - Number(b.minquantity)
                  ) || [];

              // Get the first price slab's unitPrice (lowest minQty) as default
              const defaultUnitPrice =
                priceSlabArray.length > 0
                  ? Number(priceSlabArray[0].unitPrice)
                  : 0;

              // Map line level attachments from line.dms array
              const lineAttachments =
                line.dms?.filter(
                  (dmsItem: any) => dmsItem.moduleFileType === "lineAttachments"
                ) || [];

              // Get tax information
              const taxName = line.taxName || "";
              const taxPercentage = Number(line.taxPercentage) || 0;
              const isIGST = taxName.toUpperCase().includes("IGST");

              return {
                lineNo: line.rateContractLineId,
                uuid: nanoid(),
                materialId: line.materialId,
                materialName: line.materialId,
                materialLabel: line.materialName,
                categoryId: line.categoryId,
                materialCategory: line.categoryId,
                materialCategoryLabel: line.categoryName,
                hsnCode: line.hsnCode || "",
                uomId: line.uomId,
                uomLabel: line.uomName,
                quantity: 0, // Not in contract, set default
                unitPrice: defaultUnitPrice,
                priceSlabArray: priceSlabArray,
                taxName: taxName,
                taxPercentage: taxPercentage,
                // Keep these for backward compatibility if needed
                cgst: 0,
                cgstPercentage: isIGST ? 0 : taxPercentage / 2,
                cgstAmount: 0,
                sgst: 0,
                sgstPercentage: isIGST ? 0 : taxPercentage / 2,
                sgstAmount: 0,
                igst: 0,
                igstPercentage: isIGST ? taxPercentage : 0,
                igstAmount: 0,
                amount: 0,
                grossTotal: 0,
                lineTotal: 0,
                attachment: lineAttachments.length > 0,
                file: lineAttachments.length > 0 ? lineAttachments[0] : null,
                lineAttachments: lineAttachments,
              };
            }) || [],
          // Map approvals
          approvals: data.approvals || [],
          // Map org details if available
          orgDetails: data.orgDetails || {},
          // Default currency (can be updated if API provides it)
          currencyCode: "INR",
          currencySymbol: "₹",
          currencyFormat: "INR",
        };
        // Set strict mode
        const isStrict = data?.isStrictApproval === true || data?.isStrictApproval === 1;
        setIsStrictMode(isStrict);

        if (mappedData.approvals?.length > 0) {
          // Process approvals to ensure consistent case
          const processedApprovals = mappedData.approvals.map((approval: any) => ({
            ...approval,
            level: approval.level?.toLowerCase() || approval.level,
            status: approval.status?.toLowerCase() || approval.status
          }));
          mappedData.approvals = processedApprovals;

          let ids = mappedData.approvals
            ?.filter((item: any) => item?.status?.toLowerCase() !== "approved")
            ?.map((item: any) => item?.userId);
          setApproverIds(ids);
        }

        setOriginalData(mappedData);
        setPoStatus(mappedData.orderStatus);

        // Set tax configuration based on taxName from first line item
        const firstLine = data.contractLines?.[0];
        const taxName = firstLine?.taxName || "";
        const isIGST = taxName.toUpperCase().includes("IGST");

        setTaxConfiguration({
          taxType: "GST",
          gstType: isIGST ? "IGST" : "CGST+SGST",
          cess: [],
        });

        // Extract DMS files (instructions, termsAndConditions, attachments)
        const dmsFiles = data.dms || [];
        setDMS(dmsFiles);

        // Extract instructions file
        const instructionsFile = dmsFiles.find(
          (dmsItem: any) => dmsItem.moduleFileType === "instructions"
        );

        // Extract terms and conditions file
        const termsAndConditionsFile = dmsFiles.find(
          (dmsItem: any) => dmsItem.moduleFileType === "termsAndConditions"
        );

        // Extract attachments (header level)
        const headerAttachments = dmsFiles
          .filter((dmsItem: any) => dmsItem.moduleFileType === "attachments")
          .map((dmsItem: any) => ({
            docId: dmsItem.docId,
            name: dmsItem.fileName,
            link: dmsItem.filePath,
          }));
        setAttachments(headerAttachments);

        // Fetch instructions HTML content
        if (instructionsFile?.filePath) {
          fetchHtmlContentFromUrl(instructionsFile.filePath).then(
            (htmlContent) => {
              if (htmlContent) {
                setInstructions(htmlContent);
                setNewInstructions(htmlContent);
              }
            }
          );
        }

        // Fetch terms and conditions HTML content
        if (termsAndConditionsFile?.filePath) {
          fetchHtmlContentFromUrl(termsAndConditionsFile.filePath).then(
            (htmlContent) => {
              if (htmlContent) {
                setTermsAndConditions(htmlContent);
                setNewTermsAndConditions(htmlContent);
              }
            }
          );
        }

        // Map line items with price slabs
        const LineItems = mappedData.lineItems.map((item: any) => ({
          ...item,
          attachment: false,
        }));

        setMaterialData({
          ...mappedData,
          lineItems: LineItems,
        });

        setShowSubmitBtm(false);
        setDeletedAttachments([]);
        setNewAttachments([]);
        setCurrency({
          description: mappedData.currencyCode,
          currency_code: mappedData.currencyCode,
          currency_symbol: mappedData.currencySymbol,
          currency_format: mappedData.currencyFormat,
          example: mappedData.currencyCode,
        });
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const parseLevelNum = (level: any) => {
    if (!level && level !== 0) return NaN;
    const str = String(level).toLowerCase();

    // Handle various level formats: level1, Level2, L1, L2, etc.
    if (str.includes('level')) {
      const match = str.match(/\d+/);
      return match ? parseInt(match[0], 10) : NaN;
    } else if (str.startsWith('l')) {
      const match = str.match(/\d+/);
      return match ? parseInt(match[0], 10) : NaN;
    }
    return NaN;
  };

  const hasUserAlreadyApproved = materialData?.approvals?.some(
    (a: any) =>
      a.userId === currentUserId &&
      a.status?.toUpperCase() === "APPROVED"
  );

  const canUserApproveReject = useCallback(() => {
    // 1. Admin can Approve/Reject anytime - Buttons are always ENABLED
    if (currentUser?.genericRole?.toLowerCase() === "admin") {
      return true;
    }

    const approvals = materialData?.approvals || [];

    // Find current user's approval entry
    const userApproval = approvals.find(
      (approval: any) => approval.userId === currentUserId
    );

    if (!userApproval || userApproval.status?.toLowerCase() !== "pending") {
      return false;
    }

    const userLevelNum = parseLevelNum(userApproval.level ?? currentUser?.approvalLevel);

    // 2. Strict = 0 (Flexible mode)
    // Anyone in the approval list can approve at any time
    if (isStrictMode === false) {
      // In flexible mode, just check if user is in the approval list and pending
      return true;
    }

    // 3. Strict = 1 (Sequential mode)
    // Must follow the order. Level 2 cannot see buttons until Level 1 is "Approved"
    if (isStrictMode === true) {
      // Get all pending approvals sorted by level
      const pendingApprovals = approvals
        .filter((approval: any) => approval.status?.toLowerCase() === "pending")
        .sort((a: any, b: any) => {
          const aNum = parseLevelNum(a.level);
          const bNum = parseLevelNum(b.level);
          if (isNaN(aNum) || isNaN(bNum)) return 0;
          return aNum - bNum;
        });

      // If there are no pending approvals, user can't approve
      if (pendingApprovals.length === 0) return false;

      // Get the first pending approval (lowest level)
      const firstPending = pendingApprovals[0];
      const firstPendingLevelNum = parseLevelNum(firstPending.level);

      // Check if user is the first pending approver
      return userApproval.userId === firstPending.userId &&
        userLevelNum === firstPendingLevelNum;
    }

    return false;
  }, [currentUser, currentUserId, materialData?.approvals, isStrictMode]);

  const getPendingStatusMessage = () => {
    const approvals = materialData?.approvals || [];
    const pendingApprovals = approvals
      .filter((approval: any) => approval.status?.toLowerCase() === "pending")
      .sort((a: any, b: any) => {
        const aNum = parseLevelNum(a.level);
        const bNum = parseLevelNum(b.level);
        if (isNaN(aNum) || isNaN(bNum)) return 0;
        return aNum - bNum;
      });

    if (pendingApprovals?.length > 0) {
      if (!isStrictMode) {
        // Flexible mode - any approver can approve
        const approverNames = pendingApprovals.map((approval: any) => approval.userName).join(", ");
        return `Status is pending. Any of these approvers can approve: ${approverNames}`;
      } else {
        // Strict mode - must follow sequence
        const nextApprover = pendingApprovals[0];
        const lvl = parseLevelNum(nextApprover.level);
        const levelText = !isNaN(lvl) ? `Level ${lvl}` : nextApprover.roleName || "";
        return `Status is pending. Waiting for ${nextApprover.userName} (${levelText}) to approve first.`;
      }
    }

    return "Status is pending by other approvers";
  };


  const ShowAddressPopOver = ({ type, id }: any) => {
    if (!id) {
      return <></>;
    }
    let address = deliveryAddressList?.find((item: any) => item?.id == id);
    if (!address) {
      return <></>;
    }
    const { cin, gstin, pan, phoneNumber } = OriginalData?.orgDetails;
    return (
      <ul>
        <li>
          <strong style={{ color: "#2263b3" }}>
            {address?.deliveryLocationName}
          </strong>
        </li>
        <li>{address?.addressLine1}</li>
        <li>{address?.addressLine2}</li>
        <li>
          {address?.city}, {address?.stateName}, {address?.countryName} -{" "}
          {address?.pincode}
        </li>
        {type == "billing" && (
          <>
            <li>
              <strong>GSTIN</strong> : {gstin}
            </li>
            <li>
              <strong>CIN</strong> : {cin}
            </li>
            <li>
              <strong>PAN</strong> : {pan}
            </li>
            <li>
              <strong>Phone</strong> : {phoneNumber}
            </li>
          </>
        )}
        {type == "delivery" && (
          <>
            <li>
              <strong>Contact Person</strong> : {address?.contactPersonName}
            </li>
            <li>
              <strong>Mobile Number</strong> : {address?.mobileNumber}
            </li>
          </>
        )}
      </ul>
    );
  };

  const fetchSupplier = async () => {
    try {
      const res: any =
        await purchaseOrderCreation.fetchBuyerLinkedSupplierListMethod();
      const { data, status } = res;
      if (status) {
        let supplierOptions = data.map((item: any) => ({
          label: item?.sellerOrg?.name,
          value: item?.sellerOrg?.orgId?.toString(),
        }));
        setSupplierOptions(supplierOptions);
        setSupplierList(data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchCostCenter = async () => {
    try {
      const { data, status, message } = await costCenterApis.fetchCostCenter();
      if (status) {
        let costCenterOptions = data.map((item: any) => {
          return { label: item.costCenterName, value: item.id.toString() };
        });
        setCostCenterOptions(costCenterOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchGeneralLedger = async () => {
    try {
      const { data, status, message } = await GeneralLedgerApis.fetchLedger();
      if (status) {
        let generalLedgerOptions = data.map((item: any) => {
          return { label: item.ledgerName, value: item.ledgerID.toString() };
        });
        setGeneralLedgerOptions(generalLedgerOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchDepartment = async () => {
    try {
      const { data, status, message } = await departments.fetchDeptData();
      if (status) {
        let departmentOptions = data.map((item: any) => {
          return { label: item.deptName, value: item.deptID.toString() };
        });
        setDepartmentOptions(departmentOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchDeliveryAddress = async () => {
    try {
      const { data, status } = await deliveryAddressApis.fetchDeliveryAddress();
      if (status) {
        let deliveryAddressOptions = data.map((item: any) => ({
          label: item.deliveryLocationName,
          value: item.id.toString(),
        }));
        setDeliveryAddressOptions(deliveryAddressOptions);
        setDeliveryAddressList(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const [columns, setColumns] = useState<TableColumnsType<any>>([
    // {
    //   ...Table.EXPAND_COLUMN,
    //   fixed: "left",
    // },
    {
      title: "#",
      key: "#",
      width: 50,
      fixed: "left",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Material Category",
      dataIndex: "materialCategoryLabel",
      key: "materialCategory",
      width: 150,
      fixed: "left",
      render: (text) => text || "--",
    },
    {
      title: "Material Name",
      dataIndex: "materialLabel",
      key: "materialName",
      width: 200,
      fixed: "left",
      render: (text) => text || "--",
    },
    {
      title: "HSN / SAC",
      dataIndex: "hsnCode",
      key: "hsnCode",
      width: 100,
      render: (text) => text || "--",
    },
    {
      title: "UOM",
      dataIndex: "uomLabel",
      key: "uomLabel",
      width: 150,
      render: (text) => text || "--",
    },
    {
      title: "Tax (%)",
      key: "tax",
      width: 150,
      render: (text: any, record: any) => {
        const taxName = record.taxName || "";
        const taxPercentage = record.taxPercentage || 0;
        if (taxName && taxPercentage > 0) {
          return `${taxName} (${Number(taxPercentage)}%)`;
        } else if (taxName) {
          return `${taxName} (${Number(taxPercentage)}%)`;
        }
        return "--";
      },
    },
    // {
    //   title: "Unit Price",
    //   dataIndex: "unitPrice",
    //   key: "unitPrice",
    //   width: 150,
    //   render: (text) =>
    //     text ? formatCurrency(Number(text), currency?.currency_code) : "",
    // },
  ]);

  const configColumns = (cols: any[]) => {
    return cols.filter((col) => {
      // Hide columns that are marked as hidden
      if (col.hidden) {
        return false;
      }
      return true;
    });
  };

  useEffect(() => {
    if (editLineRow) {
      setAddNewRowModel(true);
    }
  }, [editLineRow]);

  const ShowSupplierInfo = ({ id }: any) => {
    let supplier = OriginalData?.supplierDetails;
    if (!supplier) {
      return <></>;
    }
    return (
      <ul>
        <li>
          <strong>Name</strong> : {OriginalData?.supplierName}
        </li>
        <li>
          <strong>GSTIN</strong> : {supplier.gstin}
        </li>
        <li>
          <strong>PAN</strong> : {supplier.pan}
        </li>
        <li>
          <strong>CIN</strong> : {supplier.cin}
        </li>
      </ul>
    );
  };

  const updateColumnsWithCurrencySymbol = useCallback(() => {
    setColumns((prevColumns) => {
      return prevColumns.map((col: any) => {
        if (col.dataIndex == "unitPrice" || col.dataIndex == "netAmount") {
          return {
            ...col,
            render: (text: any) => (
              <div className="justify-end">
                {FormatCurrency(text, currency?.currency_code)}
              </div>
            ),
          };
        }
        if (col.key == "amount") {
          return {
            title: "Basic Amount",
            key: "amount",
            width: 150,
            render: (text: any, record: any) => (
              <p className="justify-end">
                {FormatCurrency(
                  Number(record?.unitPrice) * Number(record?.quantity),
                  currency?.currency_code
                )}
              </p>
            ),
          };
        }
        if (col.key == "lineTotal") {
          return {
            title: "Line Total",
            key: "lineTotal",
            width: 150,
            fixed: "right",
            render: (text: any, record: any) => {
              return (
                <div className="justify-end">
                  {FormatCurrency(
                    Number(record?.grossTotal),
                    currency?.currency_code
                  )}
                </div>
              );
            },
          };
        }
        if (col.children) {
          let children = col.children.map((child: any) => {
            if (child.title == "Amount") {
              return {
                ...child,
                // render: (text: any) => (
                //   <div className="justify-end">
                //     {FormatCurrency(text, currency?.currency_code)}
                //   </div>
                // ),
              };
            }
            return child;
          });
          return {
            ...col,
            children,
          };
        }
        if (
          OriginalData?.needByDateType == "Order Level" &&
          col.dataIndex == "needByDate"
        ) {
          return {
            ...col,
            hidden: true,
          };
        } else if (col.dataIndex == "needByDate") {
          return {
            ...col,
            hidden: false,
          };
        }

        return col;
      });
    });
  }, [currency]);

  useEffect(() => {
    updateColumnsWithCurrencySymbol();
  }, [currency, updateColumnsWithCurrencySymbol]);

  const updateColumnsWithPoStatus = useCallback(() => {
    // Action column removed - no longer needed
    setColumns((prevColumns) => {
      return prevColumns.filter((col: any) => col.key !== "operation");
    });
  }, [poStatus]);

  useEffect(() => {
    updateColumnsWithPoStatus();
  }, [poStatus, updateColumnsWithPoStatus]);

  const updateColmnWithTaxConfiguration = useCallback(() => {
    // Tax column is always visible, no need to hide/show based on configuration
    // This function is kept for backward compatibility but doesn't need to do anything
    return;
  }, [taxConfiguration]);

  useEffect(() => {
    updateColmnWithTaxConfiguration();
  }, [taxConfiguration, updateColmnWithTaxConfiguration]);

  const ApprovalTimelineContent = () => {
    const approvalsData = materialData?.approvals;
    if (!approvalsData || approvalsData?.length === 0) {
      return <Badge color="outline-danger">No</Badge>;
    }

    return (
      <Popover
        content={
          <Timeline className="approval-timeline">
            {approvalsData?.map((approval: any, index: number) => {
              const isApproved = approval.status?.toLowerCase() == "approved";
              const isRejected = approval.status?.toLowerCase() == "rejected";
              return (
                <Timeline.Item
                  key={index}
                  dot={
                    isApproved ? (
                      <CheckCircleOutlined style={{ color: "green" }} />
                    ) : isRejected ? (
                      <CloseCircleOutlined style={{ color: "red" }} />
                    ) : undefined
                  }
                >
                  {approval?.userName}
                  <div className="designation">{approval?.roleName}</div>
                  {approval?.approvalDate && (
                    <div className="designation">
                      {dayjs(approval?.approvalDate).format("DD-MMM-YYYY")}
                    </div>
                  )}
                </Timeline.Item>
              );
            })}
          </Timeline>
        }
        title={<span style={{ color: "#2263b3" }}>Approval Hierarchy</span>}
      >
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          cursor: "pointer"
        }}>
          <span
            style={{
              color: "#2263b3",
            }}
          >
            <Badge color="outline-success">Yes</Badge>
          </span>
          {isStrictMode && (
            <Badge
              color="warning"
              style={{
                fontSize: "11px",
                cursor: "pointer",
                marginLeft: "4px"
              }}
              title="Sequential approvals required, Approvals must follow the sequence"
            >
              Strict
            </Badge>
          )}
        </div>
      </Popover>
    );
  };

  const SubmitChanges = async () => {
    try {
      const _formData = new FormData();
      const updatedLineItems: any = [];
      const newLineItems: any = [];
      const deletedLineItems: any = [];

      const newfiledata: any = [];
      const deletedFileData: any = [...deletedAttachments];
      const updatedFileData: any = [];

      materialData?.lineItems?.forEach((data: any) => {
        if (!data?.lineNo) {
          // new item
          newLineItems.push({
            uuid: data.uuid,
            needByDate: dayjs(data?.needByDate).format("YYYY-MM-DD"),
            materialId: Number(data.materialId),
            hsnCode: data?.hsnCode ? Number(data.hsnCode) : null,
            categoryId: Number(data.categoryId),
            description: data.description,
            deliveryAddressId: Number(data.deliveryAddressId),
            quantity: Number(data.quantity),
            uomId: Number(data.uomId),
            unitPrice: Number(data.unitPrice),
            discountPercentage: 0,
            sgstPercentage: Number(data.sgstPercentage),
            cgstPercentage: Number(data.cgstPercentage),
            igstPercentage: Number(data.igstPercentage),
            additionalCharges: 0,
          });
          if (data?.file && data?.file[0]) {
            _formData.append("files", data?.file[0]);
            newfiledata.push({
              indexOfFileLocated: newfiledata.length,
              module: "po",
              purpose: "special instructions",
              level: "Line Level",
              uniqueId: data.uuid,
              action: "Create",
            });
          }
        } else {
          // check for update
          const OData = OriginalData?.lineItems?.find(
            (item: any) => item.lineNo == data.lineNo
          );

          let updatedItem: any = {};

          if (Number(OData.quantity) !== Number(data.quantity)) {
            updatedItem.quantity = Number(data.quantity);
          }

          if (Number(OData.unitPrice) !== Number(data.unitPrice)) {
            updatedItem.unitPrice = Number(data.unitPrice);
          }

          if (Number(OData.hsnCode) !== Number(data.hsnCode)) {
            updatedItem.hsnCode = data.hsnCode;
          }

          if (Number(OData.categoryId) !== Number(data.categoryId)) {
            updatedItem.categoryId = Number(data.categoryId);
          }

          if (OData.description !== data.description) {
            updatedItem.description = data.description;
          }

          if (Number(OData.uomId) !== Number(data.uomId)) {
            updatedItem.uomId = Number(data.uomId);
          }

          if (Number(OData.discountPercentage) !== 0) {
            updatedItem.discountPercentage = 0;
          }

          if (Number(OData.sgstPercentage) !== Number(data.sgstPercentage)) {
            updatedItem.sgstPercentage = Number(data.sgstPercentage);
          }

          if (Number(OData.cgstPercentage) !== Number(data.cgstPercentage)) {
            updatedItem.cgstPercentage = Number(data.cgstPercentage);
          }

          if (Number(OData.igstPercentage) !== Number(data.igstPercentage)) {
            updatedItem.igstPercentage = Number(data.igstPercentage);
          }

          if (Number(OData.additionalCharges) !== 0) {
            updatedItem.additionalCharges = 0;
          }

          if (Object.keys(updatedItem).length > 0) {
            if (OriginalData?.needByDateType == "Line Level") {
              updatedItem.needByDate = dayjs(data.needByDate).format(
                "YYYY-MM-DD"
              );
            }
            if (OriginalData?.deliveryAddressType == "Line Level") {
              updatedItem.deliveryAddressId = Number(data.deliveryAddressId);
            }
            updatedItem.materialId = Number(data.materialId);
            updatedItem.lineNo = data.lineNo;
            updatedItem.uuid = OData.uuid;
            updatedLineItems.push(updatedItem);
          }

          if (data?.file && data?.file[0]) {
            if (OData?.file?.docId) {
              deletedFileData.push({
                docId: OData?.file?.docId,
              });
            }
            newfiledata.push({
              indexOfFileLocated: newfiledata.length,
              module: "po",
              purpose: "special instructions",
              level: "Line Level",
              uniqueId: OData.uuid,
              action: "Create",
            });
            console.log("newfiledata");

            _formData.append("files", data.file[0]);
          }
        }
      });

      newAttachments.forEach((attachment: any, index: number) => {
        if (!attachment) {
          return;
        }
        const file = attachment?.originFileObj;

        _formData.append("files", file);
        newfiledata.push({
          indexOfFileLocated: newfiledata.length,
          module: "po",
          purpose: "attachments",
          level: "Header Level",
          uniqueId: "",
          action: "Create",
        });
      });

      const existingLineItems: any = [];
      OriginalData?.lineItems?.forEach((item: any) => {
        if (item?.lineNo) {
          const obj: any = {
            lineNo: item.lineNo,
            uuid: item.uuid,
            materialId: item.materialId,
          };
          if (OriginalData?.needByDateType == "Line Level") {
            obj.needByDate = item.needByDate;
          }
          if (OriginalData?.deliveryAddressType == "Line Level") {
            obj.deliveryAddressId = item.deliveryAddressId;
          }
          existingLineItems.push(obj);
        }
      });

      const submitData: any = {
        mode: ["Pending Approval", "Approved"].includes(
          OriginalData?.orderStatus
        )
          ? "U"
          : "UCR",
        needByDateType: OriginalData?.needByDateType,
        deliveryAddressType: OriginalData?.deliveryAddressType,
        combinedLineItems: {
          existingLineItems,
          updatedLineItems,
          newLineItems,
          deletedLineItems,
        },
      };
      if (OriginalData?.needByDateType != "Line Level") {
        submitData.needByDate = OriginalData?.needByDate;
      }
      if (OriginalData?.deliveryAddressType != "Line Level") {
        submitData.deliveryAddressId = OriginalData?.deliveryAddressId;
      }

      const addIfDifferent = (
        key: string,
        dataValue: any,
        materialValue: any
      ) => {
        if (dataValue != materialValue) {
          submitData[key] = dataValue;
        }
      };

      const checkAndAdd = (key: string, dataValue: any, materialValue: any) => {
        // if (OriginalData.hasOwnProperty(key)) {
        addIfDifferent(key, dataValue, materialValue);
        // }
      };

      checkAndAdd(
        "supplierId",
        Number(materialData?.supplierId),
        Number(OriginalData?.supplierId)
      );
      checkAndAdd(
        "description",
        materialData?.description,
        OriginalData?.description
      );
      checkAndAdd(
        "costCenterId",
        materialData?.costCenterId ? Number(materialData?.costCenterId) : null,
        OriginalData?.costCenterId ? Number(OriginalData?.costCenterId) : null
      );
      checkAndAdd(
        "siteId",
        Number(materialData?.siteId),
        Number(OriginalData?.siteId)
      );
      checkAndAdd(
        "ledgerId",
        materialData?.ledgerId ? Number(materialData?.ledgerId) : null,
        OriginalData?.ledgerId ? Number(OriginalData?.ledgerId) : null
      );
      checkAndAdd(
        "departmentId",
        Number(materialData?.departmentId),
        Number(OriginalData?.departmentId)
      );
      checkAndAdd(
        "budgetId",
        Number(materialData?.budgetId),
        Number(OriginalData?.budgetId)
      );
      checkAndAdd(
        "contractorId",
        materialData?.contractorId ? Number(materialData?.contractorId) : null,
        OriginalData?.contractorId ? Number(OriginalData?.contractorId) : null
      );
      if (
        materialData?.paymentTerms != OriginalData?.paymentTerms ||
        materialData?.advancePercentage != OriginalData?.advancePercentage ||
        materialData?.creditDays != OriginalData?.creditDays
      ) {
        if (materialData?.paymentTerms == "Cash and Carry") {
          submitData["paymentTerms"] = materialData?.paymentTerms;
        } else if (materialData?.paymentTerms == "Credit") {
          submitData["paymentTerms"] = materialData?.paymentTerms;
          submitData["creditDays"] = Number(materialData?.creditDays);
        } else if (materialData?.paymentTerms == "Advance") {
          submitData["paymentTerms"] = materialData?.paymentTerms;
          submitData["advancePercentage"] = Number(
            materialData?.advancePercentage
          );
          submitData["creditDays"] = Number(materialData?.creditDays);
        }
      }
      checkAndAdd(
        "inwardRequired",
        materialData?.inwardRequired,
        OriginalData?.inwardRequired
      );
      if (
        dayjs(OriginalData?.needByDate).format("YYYY-MM-DD") !==
        dayjs(materialData?.needByDate).format("YYYY-MM-DD")
      ) {
        submitData.needByDate = dayjs(materialData?.needByDate).format(
          "YYYY-MM-DD"
        );
      }
      checkAndAdd(
        "needByDateType",
        materialData?.needByDateType,
        OriginalData?.needByDateType
      );
      if (OriginalData?.needByDateType == "order Level") {
        checkAndAdd(
          "needByDate",
          materialData?.needByDate,
          OriginalData?.needByDate
        );
      }
      checkAndAdd(
        "billingAddressId",
        Number(materialData?.billingAddressId),
        Number(OriginalData?.billingAddressId)
      );
      checkAndAdd(
        "deliveryAddressType",
        materialData?.deliveryAddressType,
        OriginalData?.deliveryAddressType
      );

      if (isInstructionsChanged) {
        const instructionsFile = new Blob([newInstructions], {
          type: "text/html",
        });
        _formData.append(
          `files`,
          new File([instructionsFile], "instructions.html", {
            type: "text/html",
          })
        );
        newfiledata.push({
          indexOfFileLocated: newfiledata.length,
          module: "po",
          purpose: "instructions",
          level: "Header Level",
          uniqueId: nanoid(4),
          action: "Create",
        });
        setIsInstructionsChanged(false);
        const _instructions = DMS?.filter(
          (item: any) => item.moduleFileType == "instructions"
        );
        if (_instructions?.length > 0) {
          _instructions.map((oldFile: any) => {
            deletedFileData.push({
              docId: oldFile.docId,
            });
          });
        }
      }
      if (isTermsAndConditionsChanged) {
        const termsAndConditionsFile = new Blob([newTermsAndConditions], {
          type: "text/html",
        });
        _formData.append(
          `files`,
          new File([termsAndConditionsFile], "termsAndConditions.html", {
            type: "text/html",
          })
        );
        newfiledata.push({
          indexOfFileLocated: newfiledata.length,
          module: "po",
          purpose: "termsAndConditions",
          level: "Header Level",
          uniqueId: nanoid(4),
          action: "Create",
        });
        setIsTermsAndConditionsChanged(false);
        const _termsAndConditions = DMS?.filter(
          (item: any) => item.moduleFileType == "termsAndConditions"
        );
        if (_termsAndConditions?.length > 0) {
          _termsAndConditions.map((oldFile: any) => {
            deletedFileData.push({
              docId: oldFile.docId,
            });
          });
        }
      }

      const filesData = {
        newfiledata,
        deletedFileData,
        updatedFileData,
      };

      _formData.append("filesData", JSON.stringify(filesData));

      _formData.append("files", JSON.stringify([]));
      _formData.append("orderData", JSON.stringify(submitData));
      console.log("submitData", submitData);
      const res = await purchaseOrderApis.purchaseOrderUpdate(
        orderNumber,
        _formData
      );
      const { status, message } = res;
      if (status) {
        fetchOrderDetails();
        Swal.fire("Updated!", message, "success");
        navigate(previousPath, { state: { ...extra?.previousState } });
      } else {
        Swal.fire("Error!", message, "error");
      }
    } catch (error) {
      console.log(error);
    }
    setDisableSubmit(false);
  };

  const dataURLToFile = (dataUrl: string, fileName: string): File => {
    const arr = dataUrl.split(",");
    const mimeMatch = arr[0].match(/:(.*?);/);
    const mime = mimeMatch ? mimeMatch[1] : "image/png";
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], fileName, { type: mime });
  };

  const ApprovePo = async () => {
    try {
      const signatureFiles: File[] = [];
      if (signature.image) {
        const signatureFile = dataURLToFile(
          signature.image as string,
          "signature.png"
        );
        signatureFiles.push(signatureFile);
      }

      const rateContractId = orderNumber ? Number(orderNumber) : null;
      if (!rateContractId) {
        Swal.fire("Error!", "Rate Contract ID is required", "error");
        setDisableApprove(false);
        return;
      }

      const res = await rateContract.approveRateContract(
        rateContractId,
        signatureFiles
      );
      const { status, message } = res;
      if (status) {
        fetchOrderDetails();
        Swal.fire("Approved!", message, "success");
        navigate(previousPath, { state: { ...extra?.previousState } });
      } else {
        Swal.fire("Error!", message, "error");
      }
    } catch (error) {
      console.error("Error approving rate contract:", error);
      Swal.fire("Error", "Failed to approve rate contract", "error");
    } finally {
      setDisableApprove(false);
    }
  };

  const disapprovePo = async (reason: string, files: File[] = []) => {
    try {
      setDisableReject(true);
      const rateContractId = orderNumber ? Number(orderNumber) : null;
      if (!rateContractId) {
        Swal.fire("Error!", "Rate Contract ID is required", "error");
        setDisableReject(false);
        return;
      }
      const res = await rateContract.rejectRateContract(
        rateContractId,
        reason,
        files
      );
      const { status, message } = res;
      if (status) {
        fetchOrderDetails();
        Swal.fire("Rejected!", message, "success");
        navigate(previousPath, { state: { ...extra?.previousState } });
      } else {
        Swal.fire("Error!", message, "error");
      }
    } catch (error) {
      console.error("Error rejecting rate contract:", error);
      Swal.fire("Error", "Failed to reject rate contract", "error");
    } finally {
      setDisableReject(false);
      setPendingRejectReason("");
    }
  };

  const openApproveConfirmSwal = () => {
    if (!signature.image) return;

    setIsModalApproveVisible(false);

    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Approve it!",
      cancelButtonText: "No, keep it",
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        await ApprovePo();
      } else {
        setIsModalApproveVisible(true);
      }
    });
  };

  const openRejectConfirmSwal = async () => {
    if (!signature.image) {
      Swal.fire({
        icon: "info",
        title: "Signature Required",
        text: "Please add your signature before rejecting.",
      });
      return;
    }

    setIsModalRejectedVisible(false);

    Swal.fire({
      title: "Confirm Rejection?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Reject it!",
      cancelButtonText: "Cancel",
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        const files: File[] = [];
        if (signature.image) {
          files.push(dataURLToFile(signature.image as string, "signature.png"));
        }
        await disapprovePo(pendingRejectReason, files);
      } else {
        setIsModalRejectedVisible(true);
      }
    });
  };

  const inactivateRateContract = async (reason: string) => {
    try {
      const rateContractId = orderNumber ? Number(orderNumber) : null;
      if (!rateContractId) {
        Swal.fire("Error!", "Rate Contract ID is required", "error");
        return;
      }

      const res = await rateContract.inactivateRateContract(
        rateContractId,
        reason
      );
      const { status, message } = res;
      if (status) {
        fetchOrderDetails();
        Swal.fire("Inactivated!", message, "success");
        navigate(previousPath, { state: { ...extra?.previousState } });
      } else {
        Swal.fire("Error!", message, "error");
      }
    } catch (error) {
      console.error("Error inactivating rate contract:", error);
      Swal.fire("Error", "Failed to inactivate rate contract", "error");
    } finally {
      setIsModalInactivateVisible(false);
      setPendingInactivateReason("");
    }
  };

  const openInactivateConfirmSwal = async () => {
    if (!pendingInactivateReason || !pendingInactivateReason.trim()) {
      Swal.fire({
        icon: "info",
        title: "Reason Required",
        text: "Please provide a reason for inactivation before submitting.",
      });
      return;
    }

    setIsModalInactivateVisible(false);

    Swal.fire({
      title: "Confirm Inactivation?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Inactivate it!",
      cancelButtonText: "Cancel",
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        await inactivateRateContract(pendingInactivateReason);
      } else {
        setIsModalInactivateVisible(true);
      }
    });
  };

  const rejectCR = async (reason: string) => {
    try {
      const res = await purchaseOrderApis.rejectChangeRequestOrder(
        orderNumber,
        reason
      );
      const { status, message } = res;
      if (status) {
        fetchOrderDetails();
        Swal.fire("Rejected!", message, "success");
        navigate(previousPath, { state: { ...extra?.previousState } });
      } else {
        Swal.fire("Error!", message, "error");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const AcceptCR = async () => {
    try {
      const res = await purchaseOrderApis.acceptChangeRequestOrder(orderNumber);
      const { status, message } = res;
      if (status) {
        fetchOrderDetails();
        Swal.fire("Accepted!", message, "success");
        navigate(previousPath, { state: { ...extra?.previousState } });
      } else {
        Swal.fire("Error!", message, "error");
      }
    } catch (error) {
      console.log(error);
    }
    setDisableAccept(false);
  };

  const returnBillingDetails = () => {
    const id = materialData?.billingAddressId;
    if (!id) {
      return {};
    }
    let address = deliveryAddressList?.find((item: any) => item?.id == id);
    if (!address) {
      return {};
    }
    return {
      name: currentUser?.orgName || "",
      addressLine1: address.addressLine1,
      addressLine2: address.addressLine2,
      city: address.city,
      state: address.stateName,
      pincode: address.pincode,
      country: address.countryName,
      gstin: OriginalData?.orgDetails?.gstin || "N/A",
      pan: currentUser?.pan || "",
      cin: currentUser?.cin || "",
    };
  };

  const returnSupplierDetails = () => {
    let seller = OriginalData?.supplierDetails;
    if (!seller) {
      return {};
    }
    console.log("seller::::", seller);
    const {
      city,
      stateInfo,
      countryInfo,
      pincode,
      addressline1,
      addressline2,
    } = seller?.address || {};
    return {
      name: OriginalData?.supplierName || "",
      addressLine1: addressline1 || "",
      addressLine2: addressline2 || "",
      city: city || "",
      state: stateInfo?.stateName || "",
      pincode: pincode || "",
      country: countryInfo?.countryName || "",
      gstin: seller?.gstin || "",
      pan: seller?.pan || "",
      cin: seller?.cin || "",
    };
  };

  const returnPoDetails = () => {
    const id = materialData?.deliveryAddressId;
    let address: any = {};
    if (!id) {
      address = {};
    }
    address = deliveryAddressList?.find((item: any) => item?.id == id);
    return {
      poNumber: OriginalData?.orderId,
      poDate: dayjs(OriginalData?.orderDate).format("DD-MMM-YYYY"),
      terms:
        materialData?.paymentTerms +
        (materialData?.advancePercentage
          ? `(${materialData?.advancePercentage}%)`
          : ""),
      expectedShipmentDate:
        materialData?.needByDateType == "Order Level"
          ? dayjs(materialData?.needByDate).format("DD-MMM-YYYY")
          : "Line Level Date",
      placeofSupply: address?.city || "--",
      contactPersonName: address?.contactPersonName,
      mobileNumber: address?.mobileNumber,
      creditDays:
        materialData?.paymentTerms != "Cash and Carry"
          ? materialData?.creditDays
          : 0,
      deliveryAddressString:
        [
          address?.addressLine1,
          address?.addressLine2,
          address?.city,
          address?.stateName,
          address?.pincode?.toString(),
          address?.countryName,
        ]
          ?.filter(Boolean)
          ?.join(", ") || "--",
      totals: {
        taxableAmount: formatDecimal(
          materialData?.lineItems?.reduce(
            (a: any, b: any) => a + Number(b.quantity) * Number(b.unitPrice),
            0
          )
        ),
        cgst: formatDecimal(
          materialData?.lineItems?.reduce(
            (a: any, b: any) => a + Number(b.cgst),
            0
          )
        ),
        sgst: formatDecimal(
          materialData?.lineItems?.reduce(
            (a: any, b: any) => a + Number(b.sgst),
            0
          )
        ),
        igst: formatDecimal(
          materialData?.lineItems?.reduce(
            (a: any, b: any) => a + Number(b.igst),
            0
          )
        ),
        total: formatDecimal(
          materialData?.lineItems?.reduce(
            (a: any, b: any) => a + Number(b.grossTotal),
            0
          )
        ),
      },
      lines: materialData?.lineItems?.map((item: any, index: any) => {
        let itemDescription = item?.materialName;
        if (item?.description) {
          itemDescription += "\t" + item?.description;
        }
        if (materialData?.deliveryAddressType === "Line Level") {
          let _address = deliveryAddressList?.find(
            (_item: any) => _item?.id == item?.deliveryAddressId
          );
          if (_address) {
            const addressString = [
              _address.addressLine1,
              _address.addressLine2,
              _address.city,
              _address.stateName,
              _address.pincode?.toString(),
              _address.countryName,
            ]
              .filter(Boolean)
              .join(", ");
            itemDescription += "\n\nDelivery Address: " + addressString;
          }
        }
        if (materialData?.needByDateType != "Order Level") {
          itemDescription +=
            "\n\nNeed By Date: " +
            dayjs(item?.needByDate).format("DD-MMM-YYYY");
        }
        return {
          sno: index + 1,
          itemDescription,
          hsnSac: item?.hsnCode || "",
          rate: formatDecimal(item?.unitPrice),
          cgstPercentage: Number(item?.cgstPercentage),
          cgstAmount: formatDecimal(Number(item?.cgst)),
          sgstPercentage: Number(item?.sgstPercentage),
          sgstAmount: formatDecimal(Number(item?.sgst)),
          igstPercentage: Number(item?.igstPercentage),
          igstAmount: formatDecimal(Number(item?.igst)),
          taxableAmount: formatDecimal(Number(item?.grossTotal)),
          qty: Number(item?.quantity),
          uom: item?.uomLabel,
        };
      }),
    };
  };

  const rejectedData = OriginalData?.approvals?.find(
    (item: any) => item?.status == "Rejected"
  );

  // Calculate price from price slabs based on quantity
  const calculatePriceFromSlabs = (
    priceSlabArray: any[],
    qty: number
  ): { price: number; priceId: number | null } => {
    if (!priceSlabArray || priceSlabArray.length === 0 || qty <= 0) {
      return { price: 0, priceId: null };
    }

    // Find the matching price slab for the quantity
    const matchingSlab = priceSlabArray.find((slab: any) => {
      const minQty = Number(slab.minquantity || slab.minQty || 0);
      const maxQty = Number(slab.maxquantity || slab.maxQty || 0);
      return qty >= minQty && qty <= maxQty;
    });

    if (matchingSlab) {
      return {
        price: Number(matchingSlab.unitPrice || 0),
        priceId: matchingSlab.rateContractPriceId || null,
      };
    }

    // If no matching slab found, use the first slab's price as fallback
    if (priceSlabArray.length > 0) {
      return {
        price: Number(priceSlabArray[0].unitPrice || 0),
        priceId: priceSlabArray[0].rateContractPriceId || null,
      };
    }

    return { price: 0, priceId: null };
  };

  return (
    <>
      <Head title="Rate Contract" />
      <Modal
        isOpen={generalInformationEdit}
        toggle={() => setGeneralInformationEdit(false)}
        className="modal-dialog-centered"
        size="xl"
        backdrop="static"
      >
        <a
          href="#cancel"
          onClick={(ev) => {
            ev.preventDefault();
            setGeneralInformationEdit(false);
          }}
          className="close"
        >
          <Icon name="cross-sm"></Icon>
        </a>

        <ModalBody>
          {tab === "1" && (
            <>
              <h5 className="title">Update General Information</h5>
              <div style={{ marginTop: "15px" }}></div>

              <FormProvider {...methods}>
                <form
                  className="content clearfix"
                  onSubmit={handleSubmit((data) => {
                    setMaterialData((pre: any) => {
                      const obj: any = {};

                      obj.siteName = sitesOptions.find(
                        (item) => item.value == data?.siteId
                      )?.label;

                      obj.orgName = supplierOptions.find(
                        (item) => item.value == data?.supplierId
                      )?.label;

                      obj.budgetName = budgetOptions.find(
                        (item) => item.value == data?.budgetId
                      )?.label;

                      obj.contractorName = contractorOptions.find(
                        (item) => item.value == data?.contractId
                      )?.label;

                      obj.costCenterName = costCenterOptions.find(
                        (item) => item.value == data?.costCenterId
                      )?.label;

                      obj.ledgerName = generalLedgerOptions.find(
                        (item) => item.value == data?.ledgerId
                      )?.label;

                      obj.departmentName = departmentOptions.find(
                        (item) => item.value == data?.departmentId
                      )?.label;

                      return {
                        ...pre,
                        ...data,
                        ...obj,
                      };
                    });
                    setGeneralInformationEdit(false);
                    setAddNewRowModel(false);
                    setEditLineRow(null);
                    console.log(data);
                    setShowSubmitBtm(true);
                  })}
                >
                  <Row className="gy-4">
                    <Col lg="4">
                      <FormSelect
                        name="supplierId"
                        label={`Supplier/Vendor`}
                        options={supplierOptions}
                        required={true}
                        placeholder="-Select-"
                        disabled={true}
                        tooltipText="Select the supplier or vendor for the purchase order."
                      />
                    </Col>
                    <Col lg="8">
                      <FormInput
                        name="description"
                        label="PO Description"
                        required={true}
                        type="text"
                        minLength={2}
                        maxLength={500}
                        placeholder="Enter Description"
                        tooltipText="Enter a brief description of the purchase order."
                      />
                    </Col>
                  </Row>
                  <Row className="gy-4 mt-1">
                    <Col lg="4" style={{ display: "none" }}>
                      <FormSelect
                        name="costCenterId"
                        label={`Cost Center`}
                        options={costCenterOptions}
                        placeholder="-Select-"
                        tooltipText="Select the cost center associated with this purchase order."
                      />
                    </Col>
                    <Col lg="4">
                      <FormSelect
                        name="siteId"
                        label={`Site`}
                        options={sitesOptions}
                        required={true}
                        placeholder="-Select-"
                        disabled={true}
                        tooltipText="Select the site where the materials will be used."
                      />
                    </Col>
                    <Col lg="4">
                      <FormSelect
                        name="ledgerId"
                        label={`General Ledger`}
                        options={generalLedgerOptions}
                        placeholder="-Select-"
                        tooltipText="Select the general ledger account for financial tracking."
                      />
                    </Col>
                    <Col lg="4">
                      <FormSelect
                        name="departmentId"
                        label={`Department`}
                        options={departmentOptions}
                        required={true}
                        placeholder="-Select-"
                        tooltipText="Select the department responsible for the purchase order."
                      />
                    </Col>
                  </Row>
                  <Row className="gy-4 mt-1">
                    <Col lg="4">
                      <FormSelect
                        name="budgetId"
                        label={`Budget`}
                        options={budgetOptions}
                        required={true}
                        placeholder="-Select-"
                        tooltipText="Select the budget for this purchase order."
                      />
                    </Col>
                    <Col lg="4">
                      <FormSelect
                        name="contractorId"
                        label={`Contractor`}
                        options={contractorOptions}
                        placeholder="-Select-"
                        tooltipText="Select the contractor for this purchase order."
                      />
                    </Col>
                    <Col lg="4">
                      <FormSelect
                        name="paymentTerms"
                        label="Payment Terms"
                        options={[
                          {
                            label: "Cash & Carry",
                            value: "Cash and Carry",
                          },
                          { label: "Advance", value: "Advance" },
                          { label: "Credit", value: "Credit" },
                        ]}
                        required={true}
                        placeholder="Select Payment Terms"
                        tooltipText="Select the payment terms for the purchase order."
                      />
                    </Col>
                    {watch("paymentTerms") === "Advance" && (
                      <>
                        <Col lg="4">
                          <FormInput
                            name="advancePercentage"
                            label="Advance Percentage"
                            required={true}
                            isPercentage={true}
                            placeholder="Enter Advance Percentage"
                            tooltipText="Enter the advance percentage for the purchase order."
                          />
                        </Col>
                        {watch("advancePercentage") < 100 && (
                          <Col lg="4">
                            <FormInput
                              name="creditDays"
                              label="Credit Days"
                              required={true}
                              type="number"
                              placeholder="Enter Credit Days"
                              tooltipText="Enter the credit days for the purchase order."
                              pattern={/^[1-9][0-9]*$/}
                            />
                          </Col>
                        )}
                      </>
                    )}
                    {watch("paymentTerms") === "Credit" && (
                      <Col lg="4">
                        <FormInput
                          name="creditDays"
                          label="Credit Days"
                          required={true}
                          type="number"
                          placeholder="Enter Credit Days"
                          tooltipText="Enter the credit days for the purchase order."
                          pattern={/^[1-9][0-9]*$/}
                        />
                      </Col>
                    )}
                  </Row>
                  <Row className="mt-4">
                    <Col lg="12">
                      <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                        <li>
                          <Button
                            className="btn btn-primary btn-md"
                            type="submit"
                            color="primary"
                          >
                            Save
                          </Button>
                        </li>
                        <li>
                          <a
                            href="#cancel"
                            onClick={(ev) => {
                              ev.preventDefault();
                              setGeneralInformationEdit(false);
                              reset();
                            }}
                            className="link link-light"
                          >
                            Cancel
                          </a>
                        </li>
                      </ul>
                    </Col>
                  </Row>
                </form>
              </FormProvider>
            </>
          )}
          {tab == "2" && (
            <>
              <h5 className="title"> Update Delivery Info</h5>
              <div style={{ marginTop: "15px" }}></div>
              <FormProvider {...methods}>
                <form
                  onSubmit={handleSubmit((data) => {
                    setMaterialData((pre: any) => {
                      return {
                        ...pre,
                        ...data,
                      };
                    });
                    setGeneralInformationEdit(false);
                    setAddNewRowModel(false);
                    setEditLineRow(null);
                    console.log(data);
                    setShowSubmitBtm(true);
                  })}
                >
                  <Row className="gy-4 mt-1">
                    <Col lg="4">
                      <FormSelect
                        name="inwardRequired"
                        label="Inward Required ?"
                        options={[
                          { label: "Yes", value: true },
                          { label: "No", value: false },
                        ]}
                        placeholder="-Select-"
                        tooltipText=" If GRN (Inward Process) is required for the line items then you can select 'Yes' otherwise select 'No'."
                        disabled={!["Pending Approval"].includes(poStatus)}
                      />
                    </Col>
                    <Col lg="4">
                      <FormSelect
                        name="needByDateType"
                        disabled
                        label="Line Level Delivery ?"
                        options={[
                          { label: "Yes", value: "Line Level" },
                          { label: "No", value: "Order Level" },
                        ]}
                        placeholder="-Select-"
                        tooltipText="delivery date will be based on the line level. If you select 'No' then delivery date will be based on the Order Level."
                      />
                    </Col>
                    {watch("needByDateType") == "Order Level" && (
                      <Col lg="4">
                        <FormDatePicker
                          name="needByDate"
                          label="Delivery Date"
                          required={true}
                          minDate={new Date()}
                        />
                      </Col>
                    )}
                    <Col lg="4">
                      <FormSelect
                        name="billingAddressId"
                        label={`Billing Address`}
                        options={deliveryAddressOptions}
                        disabled={!["Pending Approval"].includes(poStatus)}
                        placeholder="-Select-"
                        tooltipText="Select the billing address for the purchase order."
                      />
                    </Col>
                    <Col lg="4">
                      <FormSelect
                        name="deliveryAddressType"
                        label={`Delivery Address`}
                        disabled
                        options={[
                          { label: "Order Level", value: "Order Level" },
                          { label: "Line Level", value: "Line Level" },
                        ]}
                        placeholder="-Select-"
                        tooltipText="Select the delivery address type for the purchase order."
                      />
                    </Col>
                    {watch("deliveryAddressType") === "Order Level" && (
                      <Col lg="4">
                        <FormSelect
                          name="deliveryAddressId"
                          label="Delivery Address"
                          options={deliveryAddressOptions}
                          required={true}
                          placeholder="-Select-"
                          tooltipText="Select the delivery address for the purchase order."
                          dropdownRender={(menu) => <>{menu}</>}
                          disabled={!["Pending Approval"].includes(poStatus)}
                        />
                      </Col>
                    )}
                  </Row>
                  <Row className="mt-4">
                    <Col lg="12">
                      <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                        <li>
                          <Button
                            className="btn btn-primary btn-md"
                            type="submit"
                            color="primary"
                          >
                            Save
                          </Button>
                        </li>
                        <li>
                          <a
                            href="#cancel"
                            onClick={(ev) => {
                              ev.preventDefault();
                              setGeneralInformationEdit(false);
                              reset();
                            }}
                            className="link link-light"
                          >
                            Cancel
                          </a>
                        </li>
                      </ul>
                    </Col>
                  </Row>
                </form>
              </FormProvider>
            </>
          )}
        </ModalBody>
      </Modal>

      <RejectCR
        isModalVisible={crRejectModal}
        setIsModalVisible={setCrRejectModal}
        rejectCR={rejectCR}
      />
      <AntModal
        title="Approve Rate Contract"
        visible={isModalApproveVisible}
        onOk={() => {
          if (!signature.image) {
            Swal.fire({
              icon: "info",
              title: "Signature Required",
              text: "Please add your signature before approving.",
            });
            return;
          }
          openApproveConfirmSwal();
        }}
        onCancel={() => {
          setIsModalApproveVisible(false);
          setSignature({
            isActive: false,
            label: "Authorised Signatory",
            image: null,
          });
        }}
        okText="Submit"
        cancelText="Cancel"
        width={600}
      >
        <div className="p-3">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <span style={{ fontSize: 14, fontWeight: 600 }}>Signature</span>

            {signature.image && (
              <button
                type="button"
                onClick={() =>
                  setSignature({
                    isActive: true,
                    label: "Authorised Signatory",
                    image: null,
                  })
                }
                style={{
                  border: "none",
                  background: "transparent",
                  padding: 0,
                  cursor: "pointer",
                }}
              ></button>
            )}
          </div>

          {signature.image ? (
            <>
              <div
                className="border mb-3 d-flex justify-content-center align-items-center"
                style={{
                  padding: 16,
                  borderRadius: 8,
                  background: "#fff",
                }}
              >
                <img
                  src={signature.image}
                  alt="Signed"
                  style={{
                    maxWidth: 220,
                    maxHeight: 120,
                    objectFit: "contain",
                  }}
                />
              </div>

              <div className="d-flex justify-content-between align-items-center mb-3">
                <Button
                  size="sm"
                  color="outline-secondary"
                  onClick={() =>
                    setSignature({
                      isActive: true,
                      label: "Authorised Signatory",
                      image: null,
                    })
                  }
                >
                  Reset
                </Button>
              </div>
            </>
          ) : (
            <div
              style={{
                width: "100%",
                minHeight: 220,
                border: "2px dashed #dee2e6",
                borderRadius: 8,
                backgroundColor: "#f8f9fa",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 24,
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: 12,
                  justifyContent: "center",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <ImageUploadCropper
                  onOpenCrop={() => setIsModalApproveVisible(false)}
                  onCloseCrop={() => setIsModalApproveVisible(true)}
                  onSave={(data: string) => {
                    setSignature((prev: any) => ({ ...prev, image: data }));
                  }}
                >
                  <Button
                    color="primary"
                    size="sm"
                    outline
                    style={{ minWidth: 140 }}
                    onClick={() => setActiveSignatureContext("APPROVE")}
                  >
                    <Icon name="upload-cloud" className="me-1" />
                    Upload Image
                  </Button>
                </ImageUploadCropper>

                <Button
                  color="outline-primary"
                  size="sm"
                  style={{ minWidth: 140 }}
                  onClick={() => {
                    setIsModalApproveVisible(false);
                    setShowSignatureModel(true);
                  }}
                >
                  <Icon name="pen" className="me-1" />
                  Signature Pad
                </Button>
              </div>
            </div>
          )}
        </div>
      </AntModal>

      <AntModal
        title="Reject Rate Contract"
        visible={isModalRejectedVisible}
        onOk={() => {
          if (!pendingRejectReason || !pendingRejectReason.trim()) {
            Swal.fire({
              icon: "info",
              title: "Reason Required",
              text: "Please provide a rejection reason before submitting.",
            });
            return false;
          }
          openRejectConfirmSwal();
        }}
        onCancel={() => {
          setIsModalRejectedVisible(false);
          setPendingRejectReason("");
          setSignature({
            isActive: false,
            label: "Authorised Signatory",
            image: null,
          });
        }}
        okText="Submit"
        cancelText="Cancel"
        width={600}
      >
        <Form layout="vertical" name="rejectForm">
          <Form.Item
            name="reason"
            label="Reason for Rejection"
            rules={[{ required: true, message: "Please input your reason!" }]}
          >
            <Input.TextArea
              rows={3}
              placeholder="Type your reason here..."
              onChange={(e) => setPendingRejectReason(e.target.value)}
            />
          </Form.Item>

          <div className="mt-4">
            <strong style={{ fontSize: "16px" }}>Signature</strong>
          </div>

          {signature.image && (
            <a
              style={{ fontSize: 14, cursor: "pointer" }}
              onClick={() =>
                setSignature({
                  isActive: true,
                  label: "Authorised Signatory",
                  image: null,
                })
              }
            ></a>
          )}

          {signature.image ? (
            <>
              <div className="signatueImgWrapper border mb-3 p-3 text-center">
                <img
                  src={signature.image}
                  alt="Signed"
                  style={{ width: "180px", height: "auto" }}
                />
              </div>
              <div className="d-flex justify-content-end mb-3">
                <Button
                  size="sm"
                  color="outline-secondary"
                  className="me-2"
                  onClick={() =>
                    setSignature({
                      isActive: true,
                      label: "Authorised Signatory",
                      image: null,
                    })
                  }
                >
                  Reset
                </Button>
              </div>
            </>
          ) : (
            <div
              style={{
                minHeight: "200px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "15px",
                border: "2px dashed #dee2e6",
                borderRadius: "8px",
                backgroundColor: "#f8f9fa",
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                  justifyContent: "center",
                }}
              >
                <ImageUploadCropper
                  onOpenCrop={() => setIsModalRejectedVisible(false)}
                  onCloseCrop={() => setIsModalRejectedVisible(true)}
                  onSave={(data: string) => {
                    setSignature((prev: any) => ({ ...prev, image: data }));
                  }}
                >
                  <Button
                    color="primary"
                    size="sm"
                    outline
                    onClick={() => setActiveSignatureContext("REJECT")}
                  >
                    <Icon name="upload-cloud" className="me-1" />
                    Upload Image
                  </Button>
                </ImageUploadCropper>

                <Button
                  color="outline-primary"
                  size="sm"
                  onClick={() => {
                    setIsModalRejectedVisible(false);
                    setShowSignatureModel(true);
                  }}
                >
                  <Icon name="pen" className="me-1" />
                  Signature Pad
                </Button>
              </div>
            </div>
          )}
        </Form>
      </AntModal>

      <AntModal
        title="Inactivate Rate Contract"
        visible={isModalInactivateVisible}
        onOk={() => {
          if (!pendingInactivateReason || !pendingInactivateReason.trim()) {
            Swal.fire({
              icon: "info",
              title: "Reason Required",
              text: "Please provide a reason for inactivation before submitting.",
            });
            return false;
          }
          openInactivateConfirmSwal();
        }}
        onCancel={() => {
          setIsModalInactivateVisible(false);
          setPendingInactivateReason("");
        }}
        okText="Submit"
        cancelText="Cancel"
        width={600}
      >
        <Form layout="vertical" name="inactivateForm">
          <Form.Item
            name="reason"
            label="Reason for Inactivation"
            rules={[{ required: true, message: "Please input your reason!" }]}
          >
            <Input.TextArea
              rows={3}
              placeholder="Type your reason here..."
              onChange={(e) => setPendingInactivateReason(e.target.value)}
            />
          </Form.Item>
        </Form>
      </AntModal>

      {showSignatureModel && (
        <SignatureModal
          modal={showSignatureModel}
          toggle={() => {
            setShowSignatureModel(false);
            if (activeSignatureContext === "APPROVE") {
              setIsModalApproveVisible(true);
            } else if (activeSignatureContext === "REJECT") {
              setIsModalRejectedVisible(true);
            }
          }}
          onSave={(data: string) => {
            setSignature((prev: any) => ({ ...prev, image: data }));
            setShowSignatureModel(false);

            if (activeSignatureContext === "APPROVE") {
              setIsModalApproveVisible(true);
            } else if (activeSignatureContext === "REJECT") {
              setIsModalRejectedVisible(true);
            }
          }}
        />
      )}

      <Content>
        <Card className="card-bordered">
          <div className="card-aside-wrap">
            {!extra?.hideAside && (
              <div
                className={`card-aside card-aside-left user-aside toggle-slide toggle-slide-left toggle-break-lg ${sm ? "content-active" : ""
                  }`}
              >
                <RateContractAside updateSm={setSm} sm={sm} />
              </div>
            )}
            {isLoading == true ? (
              <>
                <Flex align="center" gap="middle" className="pageLoader">
                  <Spin size="large" className="m-auto" />
                </Flex>
              </>
            ) : (
              <div className="card-inner card-inner-lg">
                {sm && mobileView && (
                  <div
                    className="toggle-overlay"
                    onClick={() => setSm(!sm)}
                  ></div>
                )}
                <BlockHead size="lg">
                  <BlockBetween>
                    <BlockHeadContent>
                      <BlockTitle tag="h4">
                        <span>
                          {OriginalData.orderId} | {rcStatus}{" "}
                        </span>
                      </BlockTitle>
                    </BlockHeadContent>
                    {!showSubmitBtm && (
                      <div className="d-flex align-items-center">
                        {![
                          "Inactivated Contracts",
                          "Expiry in Next 30 Days",
                          "Expiry in Next 45 Days",
                          "Expired Contracts",
                        ].includes(rcStatus) && (
                            <>
                              <div className="paddingLeft10">
                                <Dropdown
                                  isOpen={shareOptionsToggle}
                                  toggle={() => {
                                    setShareOptionsToggle(!shareOptionsToggle);
                                  }}
                                >
                                  <DropdownToggle className="btn btn-white btn-outline-light">
                                    <Icon name="share"></Icon>
                                    <span>Send</span>
                                  </DropdownToggle>
                                  <DropdownMenu>
                                    <DropdownItem
                                      onClick={() => {
                                        setShowEmailModal(true);
                                      }}
                                    >
                                      <Icon name="mail"></Icon>
                                      <span>Send Mail</span>
                                    </DropdownItem>
                                  </DropdownMenu>
                                </Dropdown>
                              </div>

                              <div className="paddingLeft10">
                                <Button
                                  className="toggle"
                                  color="primary"
                                  onClick={async () => {
                                    navigate(previousPath, {
                                      state: { ...extra?.previousState },
                                    });
                                  }}
                                >
                                  <Icon name="arrow-left" />
                                  <span>Back</span>
                                </Button>
                              </div>

                              {((rcStatus === "Pending Approval"
                              ) ||
                                (poStatus === "Approved" &&
                                  OriginalData?.status === "Active") ||
                                OriginalData?.status === "Active") && (
                                  <ul className="nk-tb-actions ms-2">
                                    <li>
                                      <UncontrolledDropdown>
                                        <DropdownToggle
                                          tag="a"
                                          className="dropdown-toggle btn btn-icon btn-trigger"
                                        >
                                          <Icon name="more-v"></Icon>
                                        </DropdownToggle>
                                        <DropdownMenu end>
                                          <ul className="link-list-opt no-bdr">
                                            {rcStatus === "Pending Approval" && allowedActions?.approve == 1 &&
                                              (approverIds.includes(currentUserId) || currentUser?.genericRole?.toLowerCase() === "admin") &&
                                              !hasUserAlreadyApproved && (
                                                <>
                                                  {canUserApproveReject() ? (
                                                    <>
                                                      <li
                                                        onClick={(e) => {
                                                          e.preventDefault();
                                                          if (disableApprove) return;
                                                          setDisableApprove(true);
                                                          setActiveSignatureContext("APPROVE");
                                                          setIsModalApproveVisible(true);
                                                          const dropdown = document.querySelector(".dropdown-menu.show");
                                                          if (dropdown) {
                                                            dropdown.classList.remove("show");
                                                          }
                                                        }}
                                                      >
                                                        <Link to={`#`}>
                                                          <Icon name="check" /> Approve
                                                        </Link>
                                                      </li>
                                                      <li
                                                        onClick={(e) => {
                                                          e.preventDefault();
                                                          if (disableReject) return;
                                                          setDisableReject(true);
                                                          setActiveSignatureContext("REJECT");
                                                          setIsModalRejectedVisible(true);
                                                          const dropdown = document.querySelector(".dropdown-menu.show");
                                                          if (dropdown) {
                                                            dropdown.classList.remove("show");
                                                          }
                                                        }}
                                                      >
                                                        <Link to={`#`}>
                                                          <Icon name="cross" /> Reject
                                                        </Link>
                                                      </li>
                                                    </>
                                                  ) : (
                                                    <>
                                                      <li className="disabled" style={{ position: 'relative' }}>
                                                        <div
                                                          className="d-flex align-items-center justify-content-between w-100"
                                                          style={{
                                                            padding: "8px 16px",
                                                            opacity: 0.6,
                                                            cursor: "not-allowed",
                                                          }}
                                                        >
                                                          <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                                                            <Icon name="check" />
                                                            <span>Approve</span>
                                                          </div>
                                                          <Popover
                                                            content={
                                                              <div style={{ padding: "8px", maxWidth: "300px" }}>
                                                                <p style={{ margin: 0 }}>{getPendingStatusMessage()}</p>
                                                              </div>
                                                            }
                                                            title="Approval Status"
                                                            trigger="hover"
                                                          >
                                                            <InfoCircleOutlined
                                                              style={{
                                                                fontSize: "16px",
                                                                cursor: "pointer",
                                                                color: "#2263b3",
                                                                marginLeft: "8px"
                                                              }}
                                                            />
                                                          </Popover>
                                                        </div>
                                                      </li>
                                                      <li className="disabled">
                                                        <div
                                                          className="d-flex align-items-center"
                                                          style={{
                                                            padding: "8px 16px",
                                                            opacity: 0.6,
                                                            cursor: "not-allowed",
                                                            gap: "8px"
                                                          }}
                                                        >
                                                          <Icon name="cross" />
                                                          <span>Reject</span>
                                                        </div>
                                                      </li>
                                                    </>
                                                  )}
                                                </>
                                              )}

                                            {/* Other dropdown items */}
                                            {poStatus === "Approved" &&
                                              OriginalData?.status === "Active" && (
                                                <li>
                                                  <DropdownItem
                                                    tag="a"
                                                    href="#cardView"
                                                    onClick={(ev) => {
                                                      ev.preventDefault();
                                                      setShowConvertToPOModal(true);
                                                    }}
                                                  >
                                                    <Icon name="arrow-right" />
                                                    <span>Convert To PO</span>
                                                  </DropdownItem>
                                                </li>
                                              )}

                                            {OriginalData?.status === "Active" && (
                                              <li>
                                                <DropdownItem
                                                  tag="a"
                                                  href="#cardView"
                                                  onClick={(ev) => {
                                                    ev.preventDefault();
                                                    setIsModalInactivateVisible(true);
                                                  }}
                                                >
                                                  <Icon name="stop-circle" />
                                                  <span>Inactivate</span>
                                                </DropdownItem>
                                              </li>
                                            )}
                                          </ul>
                                        </DropdownMenu>
                                      </UncontrolledDropdown>
                                    </li>
                                  </ul>
                                )}
                              <div style={{ display: "none" }}>
                                <PdfGenerator
                                  buyerDetails={returnBillingDetails()}
                                  poDetails={returnPoDetails()}
                                  supplierDetails={returnSupplierDetails()}
                                  buyerOrgLogo={currentUser?.orgLogo}
                                  hasIGST={taxConfiguration?.gstType == "IGST"}
                                  TermsAndConditions={termsAndConditions}
                                  getPdfUrl={updatePdfBlobDataRef}
                                />
                              </div>
                            </>
                          )}
                      </div>
                    )}

                    <BlockHeadContent className="align-self-start d-lg-none">
                      <Button
                        className={`toggle btn btn-icon btn-trigger mt-n1 ${sm ? "active" : ""
                          }`}
                        onClick={() => setSm(!sm)}
                      >
                        <Icon name="menu-alt-r" />
                      </Button>
                    </BlockHeadContent>
                  </BlockBetween>
                </BlockHead>

                <Alert color={"danger"} isOpen={poStatus == "Rejected"}>
                  <strong>
                    {rejectedData?.userName} ({rejectedData?.roleName}) :{" "}
                  </strong>{" "}
                  {OriginalData?.rejectedReason}
                </Alert>

                <Alert
                  color={"danger"}
                  isOpen={poStatus == "Rejected by Supplier"}
                >
                  <strong>{OriginalData?.rejectedReason}</strong>
                </Alert>

                <Alert
                  color={"warning"}
                  isOpen={
                    OriginalData?.status === "Inactive" &&
                    OriginalData?.inactivateReason
                  }
                >
                  <strong>Reason for Inactivation: </strong>
                  {OriginalData?.inactivateReason}
                </Alert>

                <div className="content clearfix">
                  <AntCollapse defaultActiveKey={["1", "2", "3"]}>
                    <Panel
                      header={
                        <div className="d-flex align-items-center justify-content-between">
                          <>General Information</>
                        </div>
                      }
                      key="1"
                    >
                      <ul className="nav nav-tabs nav-tabs-card nav-tabs-xs w-100 p-0 m-0 position-relative">
                        <li className="nav-item" onClick={() => setTab("1")}>
                          <a
                            onClick={(ev) => {
                              ev.preventDefault();
                            }}
                            className={`nav-link${tab === "1" ? " active" : ""
                              }`}
                            href="#year"
                          >
                            General Info
                          </a>
                        </li>
                        {/* <li className="nav-item" onClick={() => setTab("2")}>
                          <a
                            href="#overview"
                            onClick={(ev) => {
                              ev.preventDefault();
                            }}
                            className={`nav-link${tab === "2" ? " active" : ""
                              }`}
                          >
                            Rate Contract Settings
                          </a>
                        </li> */}
                        {["Pending Approval"].includes(poStatus) &&
                          // ||
                          // (tab == "2" &&
                          //   ["Pending Approval", "Approved"].includes(
                          //     poStatus
                          //   ) &&
                          //   OriginalData?.needByDateType == "Order Level")
                          allowedActions?.edit == 1 ? (
                          <span
                            className="cursor-pointer position-absolute"
                            style={{
                              right: 20,
                              top: 10,
                              fontSize: "18px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              // if(["Pending Approval"].includes(poStatus)){
                              if (tab === "1") {
                                setValue("siteId", materialData?.siteId);
                                setValue(
                                  "supplierId",
                                  materialData?.supplierId
                                );
                                setValue(
                                  "description",
                                  materialData?.description
                                );
                                setValue("budgetId", materialData?.budgetId);
                                setValue(
                                  "contractorId",
                                  materialData?.contractorId
                                );
                                setValue(
                                  "paymentTerms",
                                  materialData?.paymentTerms
                                );
                                setValue(
                                  "advancePercentage",
                                  materialData?.advancePercentage
                                );
                                setValue(
                                  "creditDays",
                                  materialData?.creditDays
                                );

                                setValue(
                                  "costCenterId",
                                  materialData?.costCenterId
                                );
                                setValue("ledgerId", materialData?.ledgerId);
                                setValue(
                                  "departmentId",
                                  materialData?.departmentId
                                );
                              }
                              // else if (tab === "2") {
                              //   setValue(
                              //     "inwardRequired",
                              //     materialData?.inwardRequired
                              //   );
                              //   setValue(
                              //     "needByDateType",
                              //     materialData?.needByDateType
                              //   );
                              //   setValue(
                              //     "needByDate",
                              //     dayjs(materialData?.needByDate)
                              //   );
                              //   setValue(
                              //     "billingAddressId",
                              //     materialData?.billingAddressId
                              //   );
                              //   setValue(
                              //     "deliveryAddressType",
                              //     materialData?.deliveryAddressType
                              //   );
                              //   setValue(
                              //     "deliveryAddressId",
                              //     materialData?.deliveryAddressId
                              //   );
                              // }
                              // }else if(tab=="2"&&OriginalData?.needByDateType=="Order Level"){

                              // }
                              setGeneralInformationEdit(true);
                            }}
                          >
                            <Icon name="edit" />
                          </span>
                        ) : (
                          <></>
                        )}
                      </ul>

                      <div className="tab-content mt-0">
                        {tab === "1" && (
                          <div
                            className={`tab-pane${tab === "1" && " active"}`}
                          >
                            <Col className="justify-start w-100  flex-wrap mt-3 p-3">
                              <div className="w-30 border-end ">
                                <div className="data-col align-center pt-1 ">
                                  <div className="data-label w-30">Site</div>
                                  <div className="data-value w-70 ">
                                    {OriginalData?.siteNames?.length > 0
                                      ? OriginalData.siteNames.join(", ")
                                      : sitesOptions.find(
                                        (item) =>
                                          item.value == OriginalData.siteId
                                      )?.label || "--"}
                                  </div>
                                </div>

                                <div className="data-col align-center pt-1">
                                  <div className="data-label w-30">
                                    Description
                                  </div>
                                  <div className="data-value w-70">
                                    <Popover
                                      content={
                                        <div>
                                          <p>{OriginalData?.description}</p>
                                        </div>
                                      }
                                      title={"Description"}
                                    >
                                      {OriginalData?.description?.length >
                                        30 ? (
                                        <span
                                          style={{
                                            color: "#2263b3",
                                            textDecoration: "underline",
                                            cursor: "pointer",
                                          }}
                                        >
                                          {OriginalData?.description?.substring(
                                            0,
                                            30
                                          )}
                                          ...
                                        </span>
                                      ) : (
                                        OriginalData?.description || "--"
                                      )}
                                    </Popover>
                                  </div>
                                </div>
                                <div className="data-col align-center pt-1">
                                  <div className="data-label w-30">
                                    Approvals
                                  </div>
                                  <div className="data-value w-70">
                                    <ApprovalTimelineContent />
                                  </div>
                                </div>
                              </div>
                              <div className="w-30 border-end paddingLeft10  ">
                                <div className="data-col align-center pt-1 ">
                                  <div className="data-label w-30">
                                    Contract Type{" "}
                                  </div>
                                  <div className="data-value w-70 ">
                                    {OriginalData.contractType || "Quantity"}
                                  </div>
                                </div>
                                <div className="data-col align-center pt-1 ">
                                  <div className="data-label w-30">
                                    Contract For{" "}
                                  </div>
                                  <div className="data-value w-70 ">
                                    {OriginalData.contractFor || "Material"}
                                  </div>
                                </div>

                                <div className="data-col align-center pt-1 ">
                                  <div className="data-label w-30">
                                    Start Date
                                  </div>
                                  <div className="data-value w-70 ">
                                    {OriginalData?.startDate
                                      ? dayjs(OriginalData?.startDate).format(
                                        "DD-MMM-YYYY"
                                      )
                                      : "--"}
                                  </div>
                                </div>
                                <div className="data-col align-center pt-1 ">
                                  <div className="data-label w-30">
                                    End Date
                                  </div>
                                  <div className="data-value w-70 ">
                                    {OriginalData?.endDate
                                      ? dayjs(OriginalData?.endDate).format(
                                        "DD-MMM-YYYY"
                                      )
                                      : "--"}
                                  </div>
                                </div>
                              </div>
                              <div className="w-30  paddingLeft10  ">
                                <div className="data-col align-center pt-1 ">
                                  <div className="data-label w-30">
                                    Supplier
                                  </div>
                                  <div className="data-value w-70 ">
                                    {
                                      supplierOptions.find(
                                        (item) =>
                                          item.value == OriginalData.supplierId
                                      )?.label
                                    }
                                  </div>
                                </div>
                                <div className="data-col align-center pt-1 ">
                                  <div className="data-label w-30">
                                    Expiry Reminder
                                  </div>
                                  <div className="data-value w-70 ">
                                    {OriginalData?.expiryReminder || "40"}
                                  </div>
                                </div>

                                <div className="data-col align-center pt-1 ">
                                  <div className="data-label w-30">
                                    Payment Terms
                                  </div>
                                  <div className="data-value w-70 ">
                                    <Badge color="outline-success">
                                      {OriginalData?.paymentTerms || "--"}
                                    </Badge>
                                  </div>
                                </div>
                                {OriginalData?.paymentTerms == "Advance" && (
                                  <div className="data-col align-center pt-1 ">
                                    <div className="data-label w-30">
                                      Advance
                                    </div>
                                    <div className="data-value w-70 ">
                                      <span className="change up text-danger">
                                        {OriginalData?.advancePercentage ||
                                          "--"}
                                        %
                                      </span>
                                    </div>
                                  </div>
                                )}
                                {OriginalData?.paymentTerms !=
                                  "Cash and Carry" && (
                                    <div className="data-col align-center pt-1 ">
                                      <div className="data-label w-30">
                                        Credit Days
                                      </div>
                                      <div className="data-value w-70 ">
                                        <Badge color="outline-primary">
                                          {OriginalData?.creditDays || "--"} days
                                        </Badge>
                                      </div>
                                    </div>
                                  )}
                              </div>
                            </Col>
                          </div>
                        )}
                        {/* {tab === "2" && (
                          <div
                            className={`tab-pane${tab === "2" && " active"}`}
                          >
                            <Col className="justify-start w-100  flex-wrap mt-3 p-3">
                              <div className="w-25 border-end">
                                <div className="data-col align-center pt-1">
                                  <div className="data-label w-50">
                                    GRN Required
                                  </div>
                                  <div className="data-value w-50">
                                    {OriginalData?.inwardRequired == "true" ? (
                                      <Badge color="outline-success">Yes</Badge>
                                    ) : (
                                      // <Badge color="outline-danger">No</Badge>
                                      <Badge color="outline-success">Yes</Badge>
                                    )}
                                  </div>
                                </div>
                                <div className="data-col align-center pt-1">
                                  <div className="data-label w-50">
                                    Auto RC Document
                                  </div>
                                  <div className="data-value w-50">
                                    {OriginalData?.autoPoDoc == "true" ? (
                                      <Badge color="outline-success">Yes</Badge>
                                    ) : (
                                      // <Badge color="outline-danger">No</Badge>
                                      <Badge color="outline-success">Yes</Badge>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div className="w-25 paddingLeft10">
                                <div className="data-col align-center pt-1">
                                  <div className="data-label w-50">
                                    Rate Contract Invoicing ?
                                  </div>
                                  <div className="data-value w-50">
                                    {OriginalData?.invoicingRequired ==
                                      "true" ? (
                                      <Badge color="outline-success">Yes</Badge>
                                    ) : (
                                      // <Badge color="outline-danger">No</Badge>
                                      <Badge color="outline-success">Yes</Badge>
                                    )}
                                  </div>
                                </div>
                                <div className="data-col align-center pt-1">
                                  <div className="data-label w-50">
                                    Pricing Slabs
                                  </div>
                                  <div className="data-value w-50">
                                    {OriginalData?.priceSlabs == "true" ? (
                                      <Badge color="outline-success">Yes</Badge>
                                    ) : (
                                      // <Badge color="outline-danger">No</Badge>
                                      <Badge color="outline-success">Yes</Badge>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </Col>
                          </div>
                        )} */}
                      </div>
                    </Panel>
                    <Panel header="Material Information" key="2">
                      <div className="table-responsive poTable">
                        <div
                          style={{
                            width:
                              screenSize -
                              (extra?.reduceTableWidth || 380) +
                              "px",
                            margin: "15px auto",
                          }}
                        >
                          <Table
                            className="customTable"
                            columns={configColumns(columns)}
                            dataSource={materialData?.lineItems?.map(
                              (item: any, index: any) => ({
                                ...item,
                                key: index,
                              })
                            )}
                            scroll={{ x: 1000 }}
                            expandable={{
                              expandedRowRender: (record: any) => (
                                <div className="expandableBody">
                                  <div style={{ flex: 1, textAlign: "left" }}>
                                    {record.description && (
                                      <p style={{ margin: 0 }}>
                                        {record.description}
                                      </p>
                                    )}
                                    {record.lineAttachments &&
                                      record.lineAttachments.length > 0 && (
                                        <>
                                          <div
                                            style={{ marginTop: "15px" }}
                                          ></div>
                                          <h6>Line Attachments</h6>
                                          {record.lineAttachments.map(
                                            (attachment: any, idx: number) => (
                                              <div
                                                key={idx}
                                                style={{ marginBottom: "8px" }}
                                              >
                                                <PaperClipOutlined /> &nbsp;
                                                <a
                                                  href={attachment.filePath}
                                                  download={attachment.fileName}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                  style={{
                                                    color: "#2263b3",
                                                    textDecoration: "underline",
                                                  }}
                                                >
                                                  {attachment.fileName}
                                                </a>
                                              </div>
                                            )
                                          )}
                                        </>
                                      )}
                                    {record.attachment &&
                                      record.file &&
                                      !record.lineAttachments && (
                                        <>
                                          <div
                                            style={{ marginTop: "15px" }}
                                          ></div>
                                          <h6>Line Attachments</h6>
                                          <div>
                                            <PaperClipOutlined /> &nbsp;
                                            {record?.file?.filePath ? (
                                              <a
                                                href={record.file.filePath}
                                                download={record.file.fileName}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                              >
                                                {record.file.fileName}
                                              </a>
                                            ) : (
                                              record?.file?.name && (
                                                <a
                                                  href={URL.createObjectURL(
                                                    record.file
                                                  )}
                                                  download={record.file.name}
                                                >
                                                  {record.file.name}
                                                </a>
                                              )
                                            )}
                                          </div>
                                        </>
                                      )}
                                  </div>
                                  {record.priceSlabArray &&
                                    record.priceSlabArray.length > 0 && (
                                      <div
                                        className="lineAddress"
                                        style={{ flex: 1 }}
                                      >
                                        <h6>Price Slab</h6>
                                        <Table
                                          className="customTable"
                                          columns={[
                                            ...(OriginalData?.contractType !== "Open"
                                              ? [
                                                  {
                                                    title: "Minimum Qty",
                                                    key: "minquantity",
                                                    dataIndex: "minquantity",
                                                  },
                                                  {
                                                    title: "Maximum Qty",
                                                    key: "maxquantity",
                                                    dataIndex: "maxquantity",
                                                  },
                                                ]
                                              : []),
                                            {
                                              title: "Price per Unit",
                                              key: "unitPrice",
                                              dataIndex: "unitPrice",
                                              render: (value: any) =>
                                                formatCurrency(
                                                  Number(value),
                                                  currency?.currency_code
                                                ),
                                            },
                                          ]}
                                          dataSource={record.priceSlabArray}
                                          bordered
                                          size="small"
                                          pagination={false}
                                        />
                                      </div>
                                    )}
                                </div>
                              ),
                            }}
                            locale={{
                              emptyText: (
                                <span
                                  style={{
                                    height: "300px",
                                    color: "#333",
                                    fontSize: "16px",
                                  }}
                                >
                                  Please click on "Add New Item" to add purchase
                                  order lines.
                                </span>
                              ),
                            }}
                            bordered
                            size="middle"
                            pagination={false}
                          />
                        </div>
                        <Row
                          style={{
                            margin: "20px",
                          }}
                        >
                          <Col
                            className={`${poStatus == "Pending Approval" &&
                              allowedActions?.edit == 1
                              ? "justify-between"
                              : "justify-end"
                              }`}
                          >
                            {poStatus == "Pending Approval" &&
                              allowedActions?.edit == 1 ? (
                              <a
                                onClick={() => {
                                  setAddNewRowModel(true);
                                  setEditLineRow(null);
                                }}
                                href="#add"
                                className="addNewItem"
                              >
                                <Icon name="plus-round" />
                                <span>Add New Item</span>
                              </a>
                            ) : (
                              <></>
                            )}
                          </Col>
                        </Row>
                      </div>
                    </Panel>
                    <Panel header="Other Information" key="3">
                      <Descriptions
                        title=""
                        className="custom-description-title"
                      >
                        <Descriptions.Item label="Instructions">
                          <span
                            style={{
                              color: "#2263b3",
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            onClick={() => setInstructionsVisible(true)}
                          >
                            View
                          </span>
                        </Descriptions.Item>
                        <Descriptions.Item label="Terms and Conditions">
                          <span
                            style={{
                              color: "#2263b3",
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            onClick={() => setTermsVisible(true)}
                          >
                            View
                          </span>
                        </Descriptions.Item>

                        <Descriptions.Item label="">
                          <div>
                            <strong
                              className=""
                              style={{
                                display: "flex",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Attachments &nbsp; <PaperClipOutlined />
                              {attachments?.length === 0 &&
                                newAttachments?.length === 0 && (
                                  <div> : N/A</div>
                                )}
                            </strong>
                            <div>
                              {attachments?.length > 0 &&
                                attachments?.map(
                                  (attachment: any, index: number) => (
                                    <div
                                      key={index}
                                      className="w-100 d-flex justify-content-between"
                                      style={{ marginBottom: "8px" }}
                                    >
                                      <div>
                                        <strong>{index + 1}.</strong>
                                        &nbsp;
                                        <a
                                          href={attachment.link}
                                          download={attachment.link}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          style={{
                                            color: "#2263b3",
                                            textDecoration: "underline",
                                          }}
                                        >
                                          {attachment.name}
                                        </a>
                                        &nbsp; &nbsp; &nbsp; &nbsp;
                                      </div>
                                      <div>
                                        <a
                                          href={attachment.link}
                                          download={attachment.link}
                                          target="_blank" // Opens in a new tab
                                          rel="noopener noreferrer" // Adds security
                                          style={{
                                            color: "black",
                                            fontSize: "18px",
                                          }}
                                        >
                                          <DownloadOutlined />
                                        </a>
                                        &nbsp; &nbsp;
                                        {["Pending Approval"].includes(
                                          poStatus
                                        ) && allowedActions?.edit == 1 ? (
                                          <a
                                            style={{
                                              color: "red",
                                              fontSize: "16px",
                                            }}
                                            onClick={() => {
                                              setDeletedAttachments(
                                                (prev: any) => [
                                                  ...prev,
                                                  { docId: attachment?.docId },
                                                ]
                                              );
                                              let updatedAttachmentsList =
                                                attachments?.filter(
                                                  (item: any, i: number) =>
                                                    i != index
                                                );
                                              setAttachments(
                                                updatedAttachmentsList
                                              );
                                              setShowSubmitBtm(true);
                                            }}
                                          >
                                            <DeleteOutlined />
                                          </a>
                                        ) : (
                                          <></>
                                        )}
                                      </div>
                                    </div>
                                  )
                                )}
                              {newAttachments?.map(
                                (attachment: any, index: number) => (
                                  <div
                                    key={index}
                                    className="w-100 d-flex justify-content-between"
                                    style={{ marginBottom: "8px" }}
                                  >
                                    <div>
                                      <strong>
                                        {attachments?.length + index + 1}.
                                      </strong>
                                      &nbsp;
                                      <a
                                        href={attachment.link}
                                        download={attachment.link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                          color: "#2263b3",
                                          textDecoration: "underline",
                                        }}
                                      >
                                        {attachment?.name}
                                      </a>
                                      &nbsp; &nbsp; &nbsp; &nbsp;
                                    </div>
                                    <div>
                                      <a
                                        href={attachment.link}
                                        download={attachment.link}
                                        style={{
                                          color: "black",
                                          fontSize: "18px",
                                        }}
                                      >
                                        <DownloadOutlined />
                                      </a>
                                      &nbsp; &nbsp;
                                      <a
                                        style={{
                                          color: "red",
                                          fontSize: "16px",
                                        }}
                                        onClick={() => {
                                          setNewAttachments((prev: any) =>
                                            prev.filter(
                                              (item: any, i: number) =>
                                                i != index
                                            )
                                          );
                                          setShowSubmitBtm(true);
                                        }}
                                      >
                                        <DeleteOutlined />
                                      </a>
                                    </div>
                                  </div>
                                )
                              )}
                              {["Pending Approval"].includes(poStatus) &&
                                allowedActions?.edit == 1 ? (
                                <div className="mt-1">
                                  <Dragger
                                    beforeUpload={beforeUpload}
                                    fileList={[]}
                                    onChange={handleAttachmentChange}
                                  >
                                    <a
                                      onClick={() => { }}
                                      className="addNewItem"
                                    >
                                      <Icon name="plus-round" />
                                      <span>Add Attachment</span>
                                    </a>
                                  </Dragger>
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        </Descriptions.Item>
                      </Descriptions>
                    </Panel>
                  </AntCollapse>

                  <Block>
                    {showCropModel && (
                      <CropperComponent
                        modal={showCropModel}
                        toggle={() => setShowCropModel(!showCropModel)}
                        onSave={(data: string) => {
                          setSignature((pre: any) => {
                            return { ...pre, image: data };
                          });
                          setShowCropModel(false);
                        }}
                      />
                    )}
                    {addNewRowModel && (
                      <MaterialModal
                        modal={addNewRowModel}
                        closeModal={() => {
                          setAddNewRowModel(false);
                          setEditLineRow(null);
                        }}
                        materialCategoryOptions={materialCategoryOptions}
                        status={materialData?.orderStatus}
                        formData={{
                          action: editLineRow == null ? "add" : "edit",
                          index: editLineRow?.uuid,
                          item: editLineRow,
                        }}
                        taxConfiguration={taxConfiguration}
                        append={(data: any) => {
                          let newLineItems = materialData?.lineItems;
                          const _data = newLineItems.find((item: any) => {
                            if (
                              item.materialId == data.materialId &&
                              dayjs(item.needByDate).format("DD-MMM-YYYY") ==
                              dayjs(data.needByDate).format("DD-MMM-YYYY") &&
                              item.deliveryAddressId == data.deliveryAddressId
                            )
                              return true;
                          });

                          if (_data) {
                            Swal.fire({
                              icon: "error",
                              title: "Error",
                              text: "Material Already Added",
                            });
                            return;
                          }

                          setMaterialData((pre: any) => {
                            let { lineItems } = pre;
                            lineItems?.push(data);
                            return { ...pre, lineItems };
                          });
                          setShowSubmitBtm(true);
                        }}
                        update={(id: any, data: any) => {
                          let newLineItems = materialData?.lineItems;
                          const _data = newLineItems
                            .filter((item: any) => item.uuid != id)
                            .find((item: any) => {
                              console.log(
                                item.materialId,
                                data.materialId,
                                item.needByDate,
                                data.needByDate,
                                item.deliveryAddressId,
                                item.deliveryAddressId
                              );

                              if (
                                item.materialId == data.materialId &&
                                dayjs(item.needByDate).format("DD-MMM-YYYY") ==
                                dayjs(data.needByDate).format(
                                  "DD-MMM-YYYY"
                                ) &&
                                item.deliveryAddressId == data.deliveryAddressId
                              )
                                return true;
                            });

                          if (_data) {
                            Swal.fire({
                              icon: "error",
                              title: "Error",
                              text: " Material Already Added",
                            });
                            return;
                          }

                          newLineItems = newLineItems.map((item: any) => {
                            if (item.uuid == id) {
                              return data;
                            }
                            return item;
                          });
                          setMaterialData((pre: any) => {
                            let newData = { ...pre, lineItems: newLineItems };
                            return newData;
                          });
                          setShowSubmitBtm(true);
                        }}
                        materialsList={materialData?.lineItems?.map(
                          (row: any) => row?.materialId?.toString()
                        )}
                        needByDateType={materialData?.needByDateType}
                        deliveryAddressType={materialData?.deliveryAddressType}
                      />
                    )}
                    {changeToBuyerData && (
                      <ChangeToBuyerDrawer
                        changeToBuyerData={changeToBuyerData}
                        needByDateType={materialData?.needByDateType}
                        drawerVisible={changeToBuyerData != null}
                        closeDrawer={() => {
                          setChangeToBuyerData(null);
                        }}
                        FormatCurrency={(value: any) =>
                          FormatCurrency(value, currency?.currency_code)
                        }
                      />
                    )}
                  </Block>
                </div>
              </div>
            )}
          </div>
        </Card>
      </Content>
      {showEmailModal && (
        <EmailCreationModal
          modal={showEmailModal}
          toggle={() => setShowEmailModal(!showEmailModal)}
          sendEmail={TriggerEmail}
          body={
            <div className="w-100 p-2">
              <div className="m-auto">
                <img
                  src={currentUser?.orgLogo}
                  alt={currentUser?.orgName}
                  width="200"
                  style={{ marginTop: "20px" }}
                />
                {/* <p style={{ fontStyle: "italic", color: "#2263b3" }}>
                    Simplifying Complexities
                  </p> */}
                <div style={{ backgroundColor: "#fff", padding: "15px" }}>
                  {/* <h2 style={{ color: "#2263b3" }}>New Rate Contract"];</h2> */}
                  <p style={{ color: "#1ee0ac", fontSize: "20px" }}>
                    Dear {OriginalData?.supplierName},
                  </p>
                  <p>
                    We are pleased to inform you that a new Rate Contract"]; (
                    <strong>{OriginalData?.orderId}</strong>) has been generated
                    for your review.
                  </p>

                  <p>
                    <strong>Order Summary: </strong>
                  </p>
                  <p>
                    <strong>PO Number: </strong>
                    {OriginalData?.orderId}
                  </p>
                  <p>
                    <strong>Order Date: </strong>
                    {dayjs(OriginalData?.orderDate).format("DD-MMM-YYYY")}
                  </p>
                  <p>
                    <strong>Delivery Address: </strong>{" "}
                    {returnPoDetails()?.deliveryAddressString}
                  </p>
                  <p>
                    <strong>Total Amount: </strong>{" "}
                    {FormatCurrency(
                      OriginalData?.netAmount,
                      currency?.currency_code
                    )}
                  </p>

                  <p>
                    Please review the attached document for full order details
                    and confirm receipt.
                  </p>
                  <p>
                    If you have any questions or need further assistance, feel
                    free to reach out to us at{" "}
                    <a href={`mailto:{${currentUser?.email}}}`}>
                      {currentUser?.email}
                    </a>
                    .
                  </p>

                  <p>
                    This is an automatically generated email. Please do not
                    reply directly to this email.
                  </p>
                </div>
                {/* <p
                  style={{
                    marginTop: "20px",
                    fontSize: "12px",
                    color: "#000",
                  }}
                >
                  Copyright © {dayjs().format("DD-MMM-YYYY")} Procurex
                  Technologies PVT LTD. All rights reserved.
                </p> */}
              </div>
            </div>
          }
          defaultAttachments={Object.assign({}, pdfBlobData.current, {
            name: OriginalData?.orderId + ".pdf",
            type: "application/pdf",
          })}
        />
      )}

      <AntModal
        title={undefined}
        visible={instructionsVisible}
        footer={null}
        onCancel={() => {
          setIsInstructionsChanged(false);
          setInstructionsVisible(false);
        }}
        width="60%"
        bodyStyle={{ maxHeight: "70vh", overflowY: "auto" }}
      >
        <div className="d-flex">
          <h5 className="m-3">Instructions </h5>
          {!isInstructionsChanged &&
            ["Pending Approval"].includes(poStatus) &&
            allowedActions?.edit == 1 && (
              <EditOutlined onClick={() => setIsInstructionsChanged(true)} />
            )}
        </div>
        {["Pending Approval"].includes(poStatus) &&
          allowedActions?.edit == 1 &&
          isInstructionsChanged ? (
          <FormProvider {...methods}>
            <form>
              <div className="mt-1 mb-3">
                <FormTextArea
                  name="instructions"
                  label=""
                  placeholder="Enter Instructions"
                  required
                  rows={10}
                  defaultValue={newInstructions}
                />
              </div>
            </form>
          </FormProvider>
        ) : instructions ? (
          <pre className="m-3">{instructions || ""}</pre>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "200px",
            }}
          >
            <Empty description="No Instructions Available for this Rate Contract" />
          </div>
        )}
        {isInstructionsChanged && (
          <ul className="actions clearfix d-flex">
            <li>
              <Button
                color="primary"
                type="submit"
                onClick={() => {
                  setInstructionsVisible(false);
                  setIsInstructionsChanged(true);
                  setShowSubmitBtm(true);
                }}
              >
                Submit
              </Button>
            </li>
            <li className="m-3 mt-0">
              <Button
                color="primary"
                onClick={() => {
                  setIsInstructionsChanged(false);
                  setNewInstructions(instructions);
                }}
                className="btn-dim btn btn-secondary"
              >
                Cancel
              </Button>
            </li>
          </ul>
        )}
      </AntModal>
      <AntModal
        title={undefined}
        visible={termsVisible}
        footer={null}
        onCancel={() => {
          setIsTermsAndConditionsChanged(false);
          setTermsVisible(false);
        }}
        width="60%"
        bodyStyle={{ maxHeight: "70vh", overflowY: "auto" }}
      >
        <div className="d-flex">
          <h5 className="m-3">Terms and Conditions</h5>
          {!isTermsAndConditionsChanged &&
            ["Pending Approval"].includes(poStatus) &&
            allowedActions?.edit == 1 && (
              <EditOutlined
                onClick={() => setIsTermsAndConditionsChanged(true)}
              />
            )}
        </div>
        {["Pending Approval"].includes(poStatus) &&
          allowedActions?.edit == 1 &&
          isTermsAndConditionsChanged ? (
          <FormProvider {...methods}>
            <form>
              <div className="mt-1 mb-3">
                <FormTextArea
                  defaultValue={newTermsAndConditions}
                  name="termsAndConditions"
                  label=""
                  placeholder="Enter Terms and Conditions"
                  required
                  rows={10}
                />
              </div>
            </form>
          </FormProvider>
        ) : termsAndConditions ? (
          <pre className="m-3">{termsAndConditions || ""}</pre>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "200px",
            }}
          >
            <Empty description="No Terms and Conditions Available for this Rate Contract" />
          </div>
        )}

        {isTermsAndConditionsChanged && (
          <ul className="actions clearfix d-flex">
            <li>
              <Button
                color="primary"
                type="submit"
                onClick={() => {
                  setTermsVisible(false);
                  setIsTermsAndConditionsChanged(true);
                  setShowSubmitBtm(true);
                }}
              >
                Submit
              </Button>
            </li>
            <li className="m-3 mt-0">
              <Button
                color="primary"
                onClick={() => {
                  setIsTermsAndConditionsChanged(false);
                  setNewTermsAndConditions(termsAndConditions);
                }}
                className="btn-dim btn btn-secondary"
              >
                Cancel
              </Button>
            </li>
          </ul>
        )}
      </AntModal>

      {/* Convert to PO Modal */}
      <AntModal
        title="Convert to Purchase Order"
        visible={showConvertToPOModal}
        footer={null}
        onCancel={() => {
          setShowConvertToPOModal(false);
          setSelectedMaterialsForPO([]);
        }}
        width="80%"
        bodyStyle={{ maxHeight: "70vh", overflowY: "auto" }}
      >
        <div className="mt-3">
          <Table
            className="customTable"
            columns={[
              {
                title: "Select",
                key: "select",
                width: 80,
                render: (text: any, record: any) => (
                  <input
                    type="checkbox"
                    checked={selectedMaterialsForPO.some(
                      (item) => item.uuid === record.uuid
                    )}
                    onChange={(e) => {
                      if (e.target.checked) {
                        // Get default site (first site if multiple, or single site)
                        const defaultSiteId =
                          OriginalData?.siteId ||
                          OriginalData?.siteIds?.[0] ||
                          null;
                        setSelectedMaterialsForPO((prev) => [
                          ...prev,
                          {
                            ...record,
                            qty: 0,
                            calculatedPrice: 0,
                            rateContractLineId: record.lineNo,
                            rateContractPriceId: null,
                            siteId: defaultSiteId,
                          },
                        ]);
                      } else {
                        setSelectedMaterialsForPO((prev) =>
                          prev.filter((item) => item.uuid !== record.uuid)
                        );
                      }
                    }}
                  />
                ),
              },
              {
                title: "Material Category",
                dataIndex: "materialCategoryLabel",
                key: "materialCategory",
                width: 200,
              },
              {
                title: "Material Name",
                dataIndex: "materialLabel",
                key: "materialName",
                width: 250,
              },
              {
                title: "Site",
                key: "site",
                width: 200,
                render: (text: any, record: any) => {
                  const selectedItem = selectedMaterialsForPO.find(
                    (item) => item.uuid === record.uuid
                  );
                  if (!selectedItem) return "--";

                  // Get available sites from rate contract
                  const availableSites = sitesOptions.filter((option: any) =>
                    OriginalData?.siteIds?.includes(Number(option.value))
                  );

                  // If only one site, show it as text
                  if (availableSites.length === 1) {
                    return availableSites[0].label;
                  }

                  // Multiple sites - show dropdown
                  return (
                    <Select
                      style={{ width: "100%" }}
                      placeholder="Select Site"
                      value={
                        selectedItem.siteId
                          ? selectedItem.siteId.toString()
                          : undefined
                      }
                      onChange={(value: any) => {
                        setSelectedMaterialsForPO((prev) =>
                          prev.map((item) =>
                            item.uuid === record.uuid
                              ? {
                                ...item,
                                siteId: Number(value),
                              }
                              : item
                          )
                        );
                      }}
                    >
                      {availableSites.map((option: any) => (
                        <Select.Option key={option.value} value={option.value}>
                          {option.label}
                        </Select.Option>
                      ))}
                    </Select>
                  );
                },
              },
              {
                title: "HSN / SAC",
                dataIndex: "hsnCode",
                key: "hsnCode",
                width: 120,
              },
              {
                title: "UOM",
                dataIndex: "uomLabel",
                key: "uom",
                width: 100,
              },
              {
                title: "Quantity",
                key: "qty",
                width: 150,
                render: (text: any, record: any) => {
                  const selectedItem = selectedMaterialsForPO.find(
                    (item) => item.uuid === record.uuid
                  );
                  if (!selectedItem) return "--";

                  const isOpenContract = OriginalData?.contractType === "Open";

                  // Get overall min and max from price slabs
                  const priceSlabs = record.priceSlabArray || [];
                  let overallMin = 0;
                  let overallMax = 0;

                  if (!isOpenContract && priceSlabs.length > 0) {
                    overallMin = Math.min(
                      ...priceSlabs.map((slab: any) =>
                        Number(slab.minquantity || slab.minQty || 0)
                      )
                    );
                    overallMax = Math.max(
                      ...priceSlabs.map((slab: any) =>
                        Number(slab.maxquantity || slab.maxQty || 0)
                      )
                    );
                  }

                  return (
                    <Input
                      type="number"
                      min={isOpenContract ? 1 : overallMin}
                      max={isOpenContract ? undefined : overallMax}
                      value={selectedItem.qty || ""}
                      onChange={(e) => {
                        const qty = Number(e.target.value) || 0;

                        // Update value immediately without validation (allow typing)
                        setSelectedMaterialsForPO((prev) =>
                          prev.map((item) =>
                            item.uuid === record.uuid
                              ? {
                                ...item,
                                qty,
                              }
                              : item
                          )
                        );
                      }}
                      onBlur={(e) => {
                        const qty = Number(e.target.value) || 0;

                        if (isOpenContract) {
                          // Open contract: no min/max validation, use unitPrice from creation
                          const unitPrice = Number(record.unitPrice || 0);
                          const priceId = record.priceSlabArray?.[0]?.rateContractPriceId || null;

                          setSelectedMaterialsForPO((prev) =>
                            prev.map((item) =>
                              item.uuid === record.uuid
                                ? {
                                  ...item,
                                  qty,
                                  calculatedPrice: unitPrice,
                                  rateContractPriceId: priceId,
                                }
                                : item
                            )
                          );
                          return;
                        }

                        // Validate quantity is within price slab range (allows any value between overallMin and overallMax)
                        // Example: If slab is 10-20, user can enter 10, 12, 15, 20, etc.
                        if (qty < overallMin || qty > overallMax) {
                          Swal.fire({
                            icon: "error",
                            title: "Invalid Quantity",
                            text: `Quantity must be between ${overallMin} and ${overallMax}`,
                          });
                          // Reset to valid value
                          setSelectedMaterialsForPO((prev) =>
                            prev.map((item) =>
                              item.uuid === record.uuid
                                ? {
                                  ...item,
                                  qty: overallMin,
                                }
                                : item
                            )
                          );
                          return;
                        }

                        // Calculate price based on quantity
                        const price = calculatePriceFromSlabs(
                          record.priceSlabArray,
                          qty
                        );

                        setSelectedMaterialsForPO((prev) =>
                          prev.map((item) =>
                            item.uuid === record.uuid
                              ? {
                                ...item,
                                qty,
                                calculatedPrice: price.price,
                                rateContractPriceId: price.priceId,
                              }
                              : item
                          )
                        );
                      }}
                      placeholder="Enter Qty"
                    />
                  );
                },
              },
              {
                title: "Unit Price",
                key: "price",
                width: 150,
                render: (text: any, record: any) => {
                  const selectedItem = selectedMaterialsForPO.find(
                    (item) => item.uuid === record.uuid
                  );
                  if (!selectedItem || !selectedItem.qty) return "--";
                  return formatCurrency(
                    selectedItem.calculatedPrice || 0,
                    currency?.currency_code
                  );
                },
              },
            ]}
            dataSource={materialData?.lineItems?.map(
              (item: any, index: any) => ({
                ...item,
                key: item.uuid || index,
              })
            )}
            pagination={false}
            scroll={{ y: 400 }}
          />

          <div className="mt-4 d-flex justify-content-end">
            <Button
              color="primary"
              onClick={() => {
                const validMaterials = selectedMaterialsForPO.filter(
                  (item) => item.qty > 0
                );
                if (validMaterials.length === 0) {
                  Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "Please select at least one material and enter quantity",
                  });
                  return;
                }

                // Validate all selected materials have a site selected
                const materialsWithoutSite = validMaterials.filter(
                  (item) => !item.siteId
                );
                if (materialsWithoutSite.length > 0) {
                  Swal.fire({
                    icon: "error",
                    title: "Site Required",
                    text: "Please select a site for all selected materials",
                  });
                  return;
                }

                // Validate all quantities are within price slab ranges (skip for Open contract type)
                const isOpenContract = OriginalData?.contractType === "Open";
                let validationError = false;
                if (!isOpenContract) {
                  validMaterials.forEach((item: any) => {
                    const priceSlabs = item.priceSlabArray || [];
                    if (priceSlabs.length > 0) {
                      const overallMin = Math.min(
                        ...priceSlabs.map((slab: any) =>
                          Number(slab.minquantity || slab.minQty || 0)
                        )
                      );
                      const overallMax = Math.max(
                        ...priceSlabs.map((slab: any) =>
                          Number(slab.maxquantity || slab.maxQty || 0)
                        )
                      );

                      if (item.qty < overallMin || item.qty > overallMax) {
                        validationError = true;
                        Swal.fire({
                          icon: "error",
                          title: "Invalid Quantity",
                          text: `${item.materialLabel}: Quantity must be between ${overallMin} and ${overallMax}`,
                        });
                      }
                    }
                  });
                }

                if (validationError) {
                  return;
                }

                // Prepare conversion data
                const isIGST = taxConfiguration?.gstType === "IGST";
                // Get the site from first selected material (all should have same site for PO)
                const firstMaterialSiteId =
                  validMaterials[0]?.siteId ||
                  OriginalData?.siteId ||
                  OriginalData?.siteIds?.[0];
                const conversionData = {
                  header: {
                    supplierId: OriginalData?.supplierId,
                    siteId: firstMaterialSiteId,
                    convertedFrom: "RC",
                    rateContractId: Number(orderNumber),
                    paymentTerms: OriginalData?.paymentTerms,
                    paymentPercentage: OriginalData?.advancePercentage,
                    paymentDays: OriginalData?.creditDays,
                    igstValue: isIGST ? "1" : "0",
                  },
                  lines: validMaterials.map((item: any) => {
                    // Use taxPercentage field which stores actual tax % regardless of type
                    // igstPercentage is 0 for CGST+SGST, so we must use taxPercentage
                    const taxPercentage = item.taxPercentage || item.igstPercentage || 0;

                    // For display in dropdown, use the full percentage
                    // For API payload, divide for CGST+SGST
                    let igstPercentage = 0;
                    let cgstPercentage = 0;
                    let sgstPercentage = 0;
                    let originalTaxPercentage = taxPercentage;

                    if (taxPercentage > 0) {
                      if (isIGST) {
                        igstPercentage = taxPercentage;
                      } else {
                        cgstPercentage = taxPercentage / 2;
                        sgstPercentage = taxPercentage / 2;
                      }
                    }

                    // RC always has a taxId, so tax is configured (even if 0%)
                    const hasTax = item.taxName != null && item.taxName !== "";

                    return {
                      materialId: item.materialId?.toString(),
                      materialName: item.materialLabel,
                      categoryId: item.categoryId?.toString(),
                      categoryName: item.materialCategoryLabel,
                      hsnCode: item.hsnCode || "",
                      uomId: item.uomId?.toString(),
                      uomName: item.uomLabel,
                      quantity: item.qty,
                      unitPrice: item.calculatedPrice,
                      igstPercentage: igstPercentage,
                      cgstPercentage: cgstPercentage,
                      sgstPercentage: sgstPercentage,
                      originalTaxPercentage: originalTaxPercentage,
                      hasTax: hasTax,
                      rateContractLineId: item.rateContractLineId,
                      rateContractPriceId: item.rateContractPriceId,
                    };
                  }),
                };

                navigate("/purchase-order-new", {
                  state: { data: conversionData },
                });
              }}
            >
              Convert to PO
            </Button>
            <Button
              color="secondary"
              className="ms-2"
              onClick={() => {
                setShowConvertToPOModal(false);
                setSelectedMaterialsForPO([]);
              }}
            >
              Cancel
            </Button>
          </div>
        </div>
      </AntModal>
    </>
  );
};

const RejectCR = ({ isModalVisible, setIsModalVisible, rejectCR }: any) => {
  const [form] = Form.useForm();

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        const reason = values.reason;
        rejectCR(reason); // Call your reject function here
        form.resetFields();
        setIsModalVisible(false);
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  return (
    <AntModal
      title="Reject Change Request"
      visible={isModalVisible}
      footer={null} // Remove the default footer buttons
      onCancel={handleCancel}
    >
      <Form form={form} layout="vertical" name="rejectForm">
        <Form.Item
          name="reason"
          label="Reason for rejection"
          rules={[{ required: true, message: "Please input your reason!" }]}
        >
          <Input.TextArea placeholder="Type your reason here..." />
        </Form.Item>
        <div className="actions clearfix">
          <ul>
            <li>
              <Button color="primary" type="submit" onClick={handleOk}>
                Submit
              </Button>
            </li>
            <li>
              <Button
                color="primary"
                onClick={handleCancel}
                className="btn-dim btn btn-secondary"
              >
                Cancel
              </Button>
            </li>
          </ul>
        </div>
      </Form>
    </AntModal>
  );
};

const RejectPo = ({ isModalVisible, setIsModalVisible, rejectPo }: any) => {
  const [form] = Form.useForm();

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        const reason = values.reason;
        rejectPo(reason); // Call your reject function here
        form.resetFields();
        setIsModalVisible(false);
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  return (
    <AntModal
      title="Reject Rate Contract"
      visible={isModalVisible}
      footer={null} // Remove the default footer buttons
      onCancel={handleCancel}
    >
      <Form form={form} layout="vertical" name="rejectForm">
        <Form.Item
          name="reason"
          label="Reason for rejection"
          rules={[{ required: true, message: "Please input your reason!" }]}
        >
          <Input.TextArea placeholder="Type your reason here..." />
        </Form.Item>
        <div className="actions clearfix">
          <ul>
            <li>
              <Button color="primary" type="submit" onClick={handleOk}>
                Submit
              </Button>
            </li>
            <li>
              <Button
                color="primary"
                onClick={handleCancel}
                className="btn-dim btn btn-secondary"
              >
                Cancel
              </Button>
            </li>
          </ul>
        </div>
      </Form>
    </AntModal>
  );
};

export default ViewOrderDetails;
